import {
  protoOf180f3jzyo7rfj as protoOf,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instanceat14thlj150z as Unit_instance,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  any2h2vr68v3604v as any,
  toString30pk9tzaqopn as toString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  defineProp3hxgpk2knu2px as defineProp,
  contains1tccixv8iwdcq as contains,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$,
  sortedWith2csnbbb21k0lg as sortedWith,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  first58ocm7j58k3q as first,
  toString1pkumu07cwy4m as toString_0,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  emptyList1g2z5xcrvp2zy as emptyList,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$_0,
  last1vo29oleiqj36 as last,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  until1jbpn0z3f8lbg as until,
  copyToArray2j022khrow2yi as copyToArray,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random2jr0khaiviwto as random,
  toString14fd7g605f91p as toString_1,
  getOrNull1go7ef9ldk0df as getOrNull,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getKClass1s3j9wy1cofik as getKClass,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_connectorsComponent2vyt6vnfllddk as get_connectorsComponent,
  Companion_instance1l2xi6jq9r026 as Companion_instance,
  Companion_getInstance1cmxj7l93cwya as Companion_getInstance,
  fromConnectors3fh5yrw28qlfe as fromConnectors,
  GuestConnectionsComponent3lmt1kel5okm5 as GuestConnectionsComponent,
  HostConnectionsComponent2io202gu4n681 as HostConnectionsComponent,
  ChildComponent2d030zd3zomve as ChildComponent,
  ParentComponentw4nmaz0u9znx as ParentComponent,
  DisplayNameComponent37eao6dtqdntj as DisplayNameComponent,
  ConnectionRootComponent3fd9sp0aqznxo as ConnectionRootComponent,
  SnapRootComponent157nyaf19ls92 as SnapRootComponent,
  DraggableComponent2vg3of9uj9uwn as DraggableComponent,
  Transform2e9p9l2euepqa as Transform,
  LocalTransformComponent1ihphzx3x7pnv as LocalTransformComponent,
  Companion_getInstancebkytj44sbgxv as Companion_getInstance_0,
  PointConnector2aof4iylw00ug as PointConnector,
  ConnectorsComponent32a4eg1gtppvf as ConnectorsComponent,
  setParentsdc2yeqq589r as setParent,
  Companion_getInstance2aog3ggbb4czi as Companion_getInstance_1,
  forEachInHierarchy2h9zs3d5h4wwz as forEachInHierarchy,
  get_guestConnections389r296igrsm5 as get_guestConnections,
  get_parent37cf1epzwukp7 as get_parent,
  get_displayName36i430b21ily as get_displayName,
  Companion_getInstance3fu6fg4j4924q as Companion_getInstance_2,
  get_guests2nnamzd9jyn03 as get_guests,
  findInHierarchyzbv5qkxvu9fi as findInHierarchy,
  Companion_getInstance2l3r2ra5znuy9 as Companion_getInstance_3,
  Companion_getInstanceaxoswaeylgcr as Companion_getInstance_4,
  fromSize34pw6a0b0kii5 as fromSize,
  ColliderShapeComponent102whak4g71e2 as ColliderShapeComponent,
  Vector1cgy08ha6e7ya as Vector,
  get_colliderShapeComponent1cprwuuvy5ljn as get_colliderShapeComponent,
  __VectorIntConstructorKotlin23vz0u6hkz1es as __VectorIntConstructorKotlin,
  Companion_getInstanceblwi6p98rjjg as Companion_getInstance_5,
  Degrees1pmrlnndueajq as Degrees,
  get_connectors3o1bagte2voxy as get_connectors,
  get_productRefzq8sc1a3ab3b as get_productRef,
  get_worldPositionwj6kte5ftqpq as get_worldPosition,
  get_collider2fpb05srk6mij as get_collider,
  get_localTransform18l3q551qwat8 as get_localTransform,
  LocalTransformComponentFromPosAndRot3l4w35iqp44oh as LocalTransformComponentFromPosAndRot,
  get_axisAlignedBoundingBoxForHierarchy3uv948cp1omtd as get_axisAlignedBoundingBoxForHierarchy,
  get_snapRoot2o0fqu30dlj6i as get_snapRoot,
  Companion_instance3fe9ns9dryzgh as Companion_instance_0,
  ViewerComponent2txqc9jweitfp as ViewerComponent,
  PolyhedronGroup3vtqeeg09ivxm as PolyhedronGroup,
  createSphereaf4ylyhldlue as createSphere,
  cloneObject365f9airlgc11 as cloneObject,
  createBox1wmf0pibluqwy as createBox,
  createPlane14kzj3v1drqgb as createPlane,
  createSurface17gaiv854e1jm as createSurface,
  groupMeshes3s0hr5pvbdigb as groupMeshes,
  createUiLineaewijqnh08r as createUiLine,
  createUiDashedLinejdroy3k38xud as createUiDashedLine,
  updateUiLinecmyi944rl109 as updateUiLine,
  loadModel16zcv8m5lo9ec as loadModel,
  debug14qh2dhfhqnvj as debug,
  createEmpty7s3anc215c9c as createEmpty,
  createGhostModel16b0p8lzbecmq as createGhostModel,
  Viewerqm0b0goijf8m as Viewer,
  setScaleV340ooszze5w83 as setScaleV,
  ViewerObject3ep46jq2f8qyh as ViewerObject,
  SizeFromVector3opll479fkt93 as SizeFromVector,
  $serializer_getInstance2cm4qg7o1asp1 as $serializer_getInstance,
  Companion_instance36lwzgsqf57la as Companion_instance_1,
  ViewerObjectComponent27r4begfll99a as ViewerObjectComponent,
  SystemBase5u6rlp403okv as SystemBase,
  Companion_getInstance321ix5enib7je as Companion_getInstance_6,
  ColliderComponent2a9dwc5kghtvn as ColliderComponent,
  Companion_instance1jc5thgshmt53 as Companion_instance_2,
  SelectedComponentmjsrq13g7qiz as SelectedComponent,
  get_children2vj8fy0vljjod as get_children,
  Companion_instance11k45hlj7pzgo as Companion_instance_3,
  Companion_getInstance13kmsjhjtfw4t as Companion_getInstance_7,
} from './core-core-api.mjs';
import {
  assertEquals2dbnhvs25kxwq as assertEquals,
  assertTrue1upg56ex908m as assertTrue,
  assertFalse3p42uuboz1ile as assertFalse,
  assertNull9duwee51djh as assertNull,
} from './kotlin-kotlin-test.mjs';
import { get_isRoomPartbpuhsyvsgmwq as get_isRoomPart } from './ipex-room-definitions.mjs';
import {
  AutoAdaptHostComponent34qpeh2sq4yhu as AutoAdaptHostComponent,
  AutoAdaptGuestComponentm7ystystq256 as AutoAdaptGuestComponent,
  Companion_getInstance1kt5fbscx1wt3 as Companion_getInstance_8,
  Companion_getInstance2e1jdwk3lbb7j as Companion_getInstance_9,
  Companion_instance1ywp8gtysici as Companion_instance_4,
  Companion_getInstance1ltn888kcrvkv as Companion_getInstance_10,
} from './core-core-stl.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  SealedClassSerializer_init_$Create$1vd2fpfo2lck9 as SealedClassSerializer_init_$Create$,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  get_nullable197rfua9r7fsz as get_nullable,
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { Default_getInstance2o39jijms8bnj as Default_getInstance_0 } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(EntityWithPointConnector, 'EntityWithPointConnector');
initMetadataForClass(GuestAndHost, 'GuestAndHost');
initMetadataForCompanion(Companion);
initMetadataForClass(TestEntityFactory, 'TestEntityFactory', TestEntityFactory);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AutoAdaptExtensions, 'AutoAdaptExtensions', AutoAdaptExtensions);
initMetadataForClass(ProductWithPositionAlongDirection, 'ProductWithPositionAlongDirection');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_1);
initMetadataForCompanion(Companion_2);
initMetadataForClass(TestPlacementUtils, 'TestPlacementUtils', TestPlacementUtils);
initMetadataForCompanion(Companion_3);
initMetadataForClass(PlacementExtensions, 'PlacementExtensions', PlacementExtensions);
initMetadataForCompanion(Companion_4);
initMetadataForClass(ArrangeExtensions, 'ArrangeExtensions', ArrangeExtensions);
initMetadataForInterface(RemoteConnection, 'RemoteConnection');
initMetadataForClass(RemoteViewer, 'RemoteViewer', VOID, VOID, [Viewer]);
initMetadataForObject(RemoteViewerState, 'RemoteViewerState');
initMetadataForClass(RemoteViewerObject, 'RemoteViewerObject', VOID, VOID, [ViewerObject]);
initMetadataForCompanion(Companion_5);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Request, 'Request', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_29});
initMetadataForClass(ClearRequest, 'ClearRequest', ClearRequest, Request, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_6);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(Node, 'Node', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
initMetadataForClass(Box, 'Box', VOID, VOID, [Node], VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CreateBoxRequest, 'CreateBoxRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GroupMeshesRequest, 'GroupMeshesRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_9, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_10);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParentNode, 'ParentNode', VOID, VOID, [Node], VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_11);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LoadModelRequest, 'LoadModelRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_12);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetPositionRequest, 'SetPositionRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_13);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Position, 'Position', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_14);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetRotationRequest, 'SetRotationRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_15);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(QuaternionDTO, 'QuaternionDTO', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_16);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DeleteRequest, 'DeleteRequest', VOID, Request, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_17, VOID, [SerializerFactory]);
initMetadataForClass(TestRoomRemoteRenderer, 'TestRoomRemoteRenderer', VOID, SystemBase);
initMetadataForCompanion(Companion_18);
initMetadataForCompanion(Companion_19);
initMetadataForCompanion(Companion_20);
initMetadataForCompanion(Companion_21);
initMetadataForCompanion(Companion_22);
initMetadataForCompanion(Companion_23);
initMetadataForCompanion(Companion_24);
initMetadataForCompanion(Companion_25);
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForCompanion(Companion_28);
initMetadataForCompanion(Companion_29);
initMetadataForCompanion(Companion_30);
initMetadataForCompanion(Companion_31);
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForCompanion(Companion_35);
initMetadataForCompanion(Companion_36);
initMetadataForCompanion(Companion_37);
initMetadataForCompanion(Companion_38);
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForCompanion(Companion_41);
initMetadataForCompanion(Companion_42);
initMetadataForCompanion(Companion_43);
initMetadataForCompanion(Companion_44);
initMetadataForClass(Frame, 'Frame', Frame);
initMetadataForClass(CornerFrameWithShelvesProductStructure, 'CornerFrameWithShelvesProductStructure', CornerFrameWithShelvesProductStructure);
initMetadataForClass(CornerAddonFrame, 'CornerAddonFrame', CornerAddonFrame);
initMetadataForClass(CornerSolutions, 'CornerSolutions', CornerSolutions);
initMetadataForClass(ShoeTrayAssembly, 'ShoeTrayAssembly', ShoeTrayAssembly);
initMetadataForClass(MeshBasketAssembly, 'MeshBasketAssembly', MeshBasketAssembly);
initMetadataForClass(MeshBasketBasket, 'MeshBasketBasket', MeshBasketBasket);
initMetadataForClass(Shelf, 'Shelf', Shelf);
initMetadataForClass(ShoeShelf, 'ShoeShelf', ShoeShelf);
initMetadataForClass(Drawer, 'Drawer', Drawer);
initMetadataForClass(DoorAssembly, 'DoorAssembly', DoorAssembly);
initMetadataForClass(DoorFront, 'DoorFront', DoorFront);
initMetadataForClass(ClothesRails, 'ClothesRails', ClothesRails);
initMetadataForClass(ValetHanger, 'ValetHanger', ValetHanger);
initMetadataForClass(TDivider, 'TDivider', TDivider);
initMetadataForClass(LDivider, 'LDivider', LDivider);
initMetadataForClass(SlidingDoor, 'SlidingDoor', SlidingDoor);
initMetadataForClass(Handle, 'Handle', Handle);
initMetadataForClass(PullOutTrayWithInserts, 'PullOutTrayWithInserts', PullOutTrayWithInserts);
initMetadataForClass(DrawerMat, 'DrawerMat', DrawerMat);
initMetadataForClass(KompBoxSet, 'KompBoxSet', KompBoxSet);
initMetadataForClass(PullOutMultiUseHanger, 'PullOutMultiUseHanger', PullOutMultiUseHanger);
initMetadataForClass(InteriorSuggestion, 'InteriorSuggestion', InteriorSuggestion);
initMetadataForClass(Light, 'Light', Light);
initMetadataForClass(ShelfBox, 'ShelfBox', ShelfBox);
initMetadataForClass(FrameWithInteriors, 'FrameWithInteriors', FrameWithInteriors);
initMetadataForClass(ProductStructure, 'ProductStructure', ProductStructure);
initMetadataForCompanion(Companion_45);
initMetadataForCompanion(Companion_46);
initMetadataForCompanion(Companion_47);
initMetadataForCompanion(Companion_48);
initMetadataForCompanion(Companion_49);
initMetadataForCompanion(Companion_50);
initMetadataForCompanion(Companion_51);
initMetadataForCompanion(Companion_52);
initMetadataForCompanion(Companion_53);
initMetadataForCompanion(Companion_54);
initMetadataForCompanion(Companion_55);
initMetadataForCompanion(Companion_56);
initMetadataForCompanion(Companion_57);
initMetadataForClass(Frames, 'Frames', Frames);
initMetadataForClass(FrameFrames, 'FrameFrames', FrameFrames);
initMetadataForClass(DoorAssembly_0, 'DoorAssembly', DoorAssembly_0);
initMetadataForClass(Front, 'Front', Front);
initMetadataForClass(DrawerAssemblies, 'DrawerAssemblies', DrawerAssemblies);
initMetadataForClass(DrawerBodies, 'DrawerBodies', DrawerBodies);
initMetadataForClass(Legs, 'Legs', Legs);
initMetadataForClass(Shelves, 'Shelves', Shelves);
initMetadataForClass(TopPanels, 'TopPanels', TopPanels);
initMetadataForClass(Knob, 'Knob', Knob);
initMetadataForClass(Handle_0, 'Handle', Handle_0);
initMetadataForClass(ProductStructure_0, 'ProductStructure', ProductStructure_0);
initMetadataForCompanion(Companion_58);
initMetadataForClass(CAX, 'CAX', CAX);
initMetadataForClass(CESTA, 'CESTA', CESTA);
initMetadataForCompanion(Companion_59);
initMetadataForClass(CTRItemNo, 'CTRItemNo', CTRItemNo);
initMetadataForClass(CountSystem, 'CountSystem', CountSystem, SystemBase);
initMetadataForCompanion(Companion_60);
initMetadataForClass(RoomTestHelper, 'RoomTestHelper', RoomTestHelper);
initMetadataForClass(VoidConnection, 'VoidConnection', VoidConnection, VOID, [RemoteConnection]);
//endregion
function EntityWithPointConnector(entity, connector) {
  this.entity = entity;
  this.connector = connector;
}
protoOf(EntityWithPointConnector).v2i = function () {
  return this.entity;
};
protoOf(EntityWithPointConnector).t1m = function () {
  return this.connector;
};
protoOf(EntityWithPointConnector).tf = function () {
  return this.entity;
};
protoOf(EntityWithPointConnector).uf = function () {
  return this.connector;
};
protoOf(EntityWithPointConnector).x5t = function (entity, connector) {
  return new EntityWithPointConnector(entity, connector);
};
protoOf(EntityWithPointConnector).copy = function (entity, connector, $super) {
  entity = entity === VOID ? this.entity : entity;
  connector = connector === VOID ? this.connector : connector;
  return this.x5t(entity, connector);
};
protoOf(EntityWithPointConnector).toString = function () {
  return 'EntityWithPointConnector(entity=' + this.entity.toString() + ', connector=' + this.connector.toString() + ')';
};
protoOf(EntityWithPointConnector).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + this.connector.hashCode() | 0;
  return result;
};
protoOf(EntityWithPointConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityWithPointConnector))
    return false;
  var tmp0_other_with_cast = other instanceof EntityWithPointConnector ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!this.connector.equals(tmp0_other_with_cast.connector))
    return false;
  return true;
};
function GuestAndHost(guest, host) {
  this.guest = guest;
  this.host = host;
}
protoOf(GuestAndHost).t3c = function () {
  return this.guest;
};
protoOf(GuestAndHost).s3c = function () {
  return this.host;
};
protoOf(GuestAndHost).tf = function () {
  return this.guest;
};
protoOf(GuestAndHost).uf = function () {
  return this.host;
};
protoOf(GuestAndHost).y5t = function (guest, host) {
  return new GuestAndHost(guest, host);
};
protoOf(GuestAndHost).copy = function (guest, host, $super) {
  guest = guest === VOID ? this.guest : guest;
  host = host === VOID ? this.host : host;
  return this.y5t(guest, host);
};
protoOf(GuestAndHost).toString = function () {
  return 'GuestAndHost(guest=' + this.guest.toString() + ', host=' + this.host.toString() + ')';
};
protoOf(GuestAndHost).hashCode = function () {
  var result = this.guest.hashCode();
  result = imul(result, 31) + this.host.hashCode() | 0;
  return result;
};
protoOf(GuestAndHost).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GuestAndHost))
    return false;
  var tmp0_other_with_cast = other instanceof GuestAndHost ? other : THROW_CCE();
  if (!this.guest.equals(tmp0_other_with_cast.guest))
    return false;
  if (!this.host.equals(tmp0_other_with_cast.host))
    return false;
  return true;
};
function TestEntityFactory$Companion$assertCreatedRequiredHierarchy$lambda($count) {
  return function (it) {
    var tmp = $count._v;
    var tmp0_safe_receiver = get_connectorsComponent(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i2c();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.count' call
      tmp_0 = tmp1_safe_receiver.o();
    }
    var tmp2_elvis_lhs = tmp_0;
    $count._v = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    return Unit_instance;
  };
}
function TestEntityFactory$Companion$assertRevertedRequiredHierarchy$lambda($oldRequiredParent) {
  return function (it) {
    return it.equals($oldRequiredParent);
  };
}
function Companion() {
  Companion_instance_5 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.z5t_1 = [];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.a5u_1 = ['floor'];
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_1.b5u_1 = [];
  var tmp_2 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_2.c5u_1 = [];
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_3.d5u_1 = ['sut-connector'];
  var tmp_4 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_4.e5u_1 = [];
  var tmp_5 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_5.f5u_1 = [];
  var tmp_6 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_6.g5u_1 = ['sut-connector'];
}
protoOf(Companion).h5u = function () {
  return this.z5t_1;
};
protoOf(Companion).i5u = function () {
  return this.a5u_1;
};
protoOf(Companion).j5u = function () {
  return this.b5u_1;
};
protoOf(Companion).k5u = function () {
  return this.c5u_1;
};
protoOf(Companion).l5u = function () {
  return this.d5u_1;
};
protoOf(Companion).m5u = function () {
  return this.e5u_1;
};
protoOf(Companion).n5u = function () {
  return this.f5u_1;
};
protoOf(Companion).o5u = function () {
  return this.g5u_1;
};
protoOf(Companion).p5u = function (coreServices) {
  var entityManager = coreServices.entityManager;
  var tmp = Companion_instance.l2b_1;
  var tmp_0 = Companion_getInstance().ZERO;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  var _destruct__k2r9zo = this.q5u(tmp, 'guest entity', coreServices, tmp_0, tmp$ret$0, this.f5u_1, this.g5u_1, true);
  var guestEntity = _destruct__k2r9zo.tf();
  var guestConnector = _destruct__k2r9zo.uf();
  var _destruct__k2r9zo_0 = this.createEntityWithConnector$default(Companion_instance.m2b_1, 'host entity', coreServices, Companion_getInstance().ZERO, this.c5u_1, this.d5u_1, this.e5u_1);
  var hostEntity = _destruct__k2r9zo_0.tf();
  var hostConnector = _destruct__k2r9zo_0.uf();
  var connectorsDeltaTransform = hostConnector.getDeltaTransformToGuestConnectorEntity(hostEntity, guestEntity, guestConnector);
  var connection = fromConnectors(guestEntity, guestConnector, hostEntity, hostConnector, connectorsDeltaTransform);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [connection];
  entityManager.addComponent(guestEntity, new GuestConnectionsComponent(tmp$ret$3));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [connection];
  entityManager.addComponent(hostEntity, new HostConnectionsComponent(tmp$ret$6));
  entityManager.addComponent(guestEntity, new ChildComponent(hostEntity));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$9 = [guestEntity];
  entityManager.addComponent(hostEntity, new ParentComponent(tmp$ret$9));
  return new GuestAndHost(guestEntity, hostEntity);
};
protoOf(Companion).q5u = function (type, displayName, coreServices, position, tags, offers, demands, required) {
  var entityManager = coreServices.entityManager;
  var sceneManager = coreServices.sceneManager;
  var entity = entityManager.createEntity();
  entity.addComponent(new DisplayNameComponent(displayName));
  entity.addComponent(new ConnectionRootComponent());
  entity.addComponent(new SnapRootComponent());
  entity.addComponent(new DraggableComponent());
  entity.addComponent(new LocalTransformComponent(new Transform(position)));
  var connector = new PointConnector('connector', type, Companion_getInstance_0().c1x_1, VOID, VOID, VOID, tags, offers, demands, VOID, VOID, required);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [connector];
  entityManager.addComponent(entity, new ConnectorsComponent(tmp$ret$11));
  setParent(entity, sceneManager.scene);
  return new EntityWithPointConnector(entity, connector);
};
protoOf(Companion).createEntityWithConnector$default = function (type, displayName, coreServices, position, tags, offers, demands, required, $super) {
  position = position === VOID ? Companion_getInstance().ZERO : position;
  var tmp;
  if (tags === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tags;
  }
  tags = tmp;
  var tmp_0;
  if (offers === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offers;
  }
  offers = tmp_0;
  var tmp_1;
  if (demands === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demands;
  }
  demands = tmp_1;
  required = required === VOID ? false : required;
  return $super === VOID ? this.q5u(type, displayName, coreServices, position, tags, offers, demands, required) : $super.q5u.call(this, type, displayName, coreServices, position, tags, offers, demands, required);
};
protoOf(Companion).r5u = function (type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required) {
  var entityManager = coreServices.entityManager;
  var sceneManager = coreServices.sceneManager;
  var assembly = entityManager.createEntity();
  assembly.addComponent(new DraggableComponent());
  assembly.addComponent(new DisplayNameComponent(displayName));
  assembly.addComponent(new ConnectionRootComponent());
  assembly.addComponent(new SnapRootComponent());
  assembly.addComponent(new LocalTransformComponent(Companion_getInstance_0().c1x_1));
  this.s5u(type, 'left assembly child', entityManager, assembly, leftChildPos, tags, offers, demands, required);
  this.s5u(type, 'right assembly child', entityManager, assembly, rightChildPos, tags, offers, demands, required);
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  assembly.addComponent(new ConnectorsComponent(tmp$ret$0));
  setParent(assembly, sceneManager.scene);
  return assembly;
};
protoOf(Companion).createAssemblyEntityWithChildConnectors$default = function (type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required, $super) {
  required = required === VOID ? false : required;
  return $super === VOID ? this.r5u(type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required) : $super.r5u.call(this, type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required);
};
protoOf(Companion).s5u = function (type, displayName, entityManager, assembly, childPos, tags, offers, demands, required) {
  var assemblyChild = entityManager.createEntity();
  assemblyChild.addComponent(new DisplayNameComponent(displayName));
  setParent(assemblyChild, assembly);
  assemblyChild.addComponent(new LocalTransformComponent(new Transform(childPos)));
  var leftConnector = new PointConnector('connector', type, Companion_getInstance_0().c1x_1, VOID, VOID, VOID, tags, offers, demands, VOID, VOID, required);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [leftConnector];
  assemblyChild.addComponent(new ConnectorsComponent(tmp$ret$2));
  return assemblyChild;
};
protoOf(Companion).addAssemblyChildWithConnector$default = function (type, displayName, entityManager, assembly, childPos, tags, offers, demands, required, $super) {
  required = required === VOID ? false : required;
  return $super === VOID ? this.s5u(type, displayName, entityManager, assembly, childPos, tags, offers, demands, required) : $super.s5u.call(this, type, displayName, entityManager, assembly, childPos, tags, offers, demands, required);
};
protoOf(Companion).t5u = function (type, entity, entityManager, connectorLocalPos, tags, offers, demands) {
  var connector = new PointConnector('connector', type, new Transform(connectorLocalPos), VOID, VOID, VOID, tags, offers, demands);
  var previousSnappable = entity.__getComponentForKotlin(Companion_getInstance_1().id);
  // Inline function 'kotlin.collections.plus' call
  var tmp1_elvis_lhs = previousSnappable == null ? null : previousSnappable.connectors;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$10 = tmp;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [connector];
  var connectors = tmp$ret$10.concat(tmp$ret$13);
  var newSnappableComponent = new ConnectorsComponent(connectors);
  entityManager.addComponent(entity, newSnappableComponent);
  return connector;
};
protoOf(Companion).addConnectorToEntity$default = function (type, entity, entityManager, connectorLocalPos, tags, offers, demands, $super) {
  connectorLocalPos = connectorLocalPos === VOID ? Companion_getInstance().ZERO : connectorLocalPos;
  var tmp;
  if (tags === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tags;
  }
  tags = tmp;
  var tmp_0;
  if (offers === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offers;
  }
  offers = tmp_0;
  var tmp_1;
  if (demands === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demands;
  }
  demands = tmp_1;
  return $super === VOID ? this.t5u(type, entity, entityManager, connectorLocalPos, tags, offers, demands) : $super.t5u.call(this, type, entity, entityManager, connectorLocalPos, tags, offers, demands);
};
protoOf(Companion).u5u = function (entity, entityManager) {
  var connector = new PointConnector('massPoint', Companion_instance.l2b_1, Companion_getInstance_0().c1x_1, -1, VOID, VOID, this.z5t_1, this.b5u_1, this.a5u_1);
  var previousSnappable = entity.__getComponentForKotlin(Companion_getInstance_1().id);
  // Inline function 'kotlin.collections.plus' call
  var tmp1_elvis_lhs = previousSnappable == null ? null : previousSnappable.connectors;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = tmp;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = [connector];
  var connectors = tmp$ret$1.concat(tmp$ret$4);
  var newSnappableComponent = new ConnectorsComponent(connectors);
  entityManager.addComponent(entity, newSnappableComponent);
};
protoOf(Companion).v5u = function (host1, host2, guest) {
  var count = {_v: 0};
  forEachInHierarchy(guest, TestEntityFactory$Companion$assertCreatedRequiredHierarchy$lambda(count));
  var tmp = count._v;
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$0 = get_guestConnections(guest).length;
  assertEquals(tmp, tmp$ret$0);
  assertTrue(this.w5u(host1, guest));
  assertTrue(this.x5u(host1, guest));
  assertTrue(this.w5u(host2, guest));
  assertTrue(this.x5u(host2, guest));
  var entityGroupParent = ensureNotNull(get_parent(guest));
  // Inline function 'kotlin.test.assertTrue' call
  var tmp0_safe_receiver = get_parent(guest);
  var message = 'Guest should be a child of the newly created required parent but was child of ' + (tmp0_safe_receiver == null ? null : get_displayName(tmp0_safe_receiver));
  // Inline function 'com.ikea.core.test.helper.entities.Companion.assertCreatedRequiredHierarchy.<anonymous>' call
  var tmp$ret$1 = entityGroupParent.hasComponent(Companion_getInstance_2().id);
  assertTrue(tmp$ret$1, message);
  assertEquals(entityGroupParent, get_parent(host1));
  assertEquals(entityGroupParent, get_parent(host2));
  assertEquals(entityGroupParent, get_parent(guest));
  assertFalse(any(get_guests(entityGroupParent)), 'The connections should be on the actual connected entities, not the newly created parent');
  // Inline function 'kotlin.test.assertFalse' call
  var message_0 = 'something went wrong, the entity group became a child of another entity group, that should not happen\nParent was: ' + toString(get_parent(entityGroupParent));
  // Inline function 'com.ikea.core.test.helper.entities.Companion.assertCreatedRequiredHierarchy.<anonymous>' call
  var tmp$ret$2 = ensureNotNull(get_parent(entityGroupParent)).hasComponent(Companion_getInstance_2().id);
  assertFalse(tmp$ret$2, message_0);
};
protoOf(Companion).y5u = function (host1, host2, oldRequiredParent, room) {
  assertTrue(get_isRoomPart(ensureNotNull(get_parent(host1))));
  assertTrue(get_isRoomPart(ensureNotNull(get_parent(host2))));
  assertNull(findInHierarchy(room, TestEntityFactory$Companion$assertRevertedRequiredHierarchy$lambda(oldRequiredParent)), 'Required parent was still present in scene hierarchy after undo');
};
protoOf(Companion).x5u = function (host, guest) {
  var tmp0_safe_receiver = host.__getComponentForKotlin(Companion_getInstance_3().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var hostedConnections = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = hostedConnections.length;
    while (inductionVariable < last) {
      var element = hostedConnections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.entities.Companion.hasHostedConnection.<anonymous>' call
      if (element.guestConnectionRoot.equals(guest)) {
        tmp$ret$2 = true;
        break $l$block;
      }
    }
    tmp$ret$2 = false;
  }
  return tmp$ret$2;
};
protoOf(Companion).w5u = function (host, guest) {
  var tmp0_safe_receiver = guest.__getComponentForKotlin(Companion_getInstance_4().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var guestConnections = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = guestConnections.length;
    while (inductionVariable < last) {
      var element = guestConnections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.entities.Companion.hasGuestConnection.<anonymous>' call
      if (element.hostConnectionRoot.equals(host)) {
        tmp$ret$2 = true;
        break $l$block;
      }
    }
    tmp$ret$2 = false;
  }
  return tmp$ret$2;
};
protoOf(Companion).z5u = function (coreServices, displayName, position) {
  var entityManager = coreServices.entityManager;
  var host = this.createEntityWithConnector$default(Companion_instance.m2b_1, displayName, coreServices, position, this.c5u_1, this.d5u_1, this.e5u_1).tf();
  this.t5u(Companion_instance.m2b_1, host, entityManager, Companion_getInstance().RIGHT.__timesIntForKotlin(250), this.c5u_1, this.d5u_1, this.e5u_1);
  this.u5u(host, entityManager);
  return host;
};
protoOf(Companion).createHostWith2Connectors$default = function (coreServices, displayName, position, $super) {
  position = position === VOID ? Companion_getInstance().ZERO : position;
  return $super === VOID ? this.z5u(coreServices, displayName, position) : $super.z5u.call(this, coreServices, displayName, position);
};
protoOf(Companion).a5v = function (coreServices, id, size) {
  var box = coreServices.entityManager.createEntity();
  box.addComponent(new DisplayNameComponent(id));
  box.addComponent(new SnapRootComponent());
  box.addComponent(new ConnectionRootComponent());
  box.addComponent(new ColliderShapeComponent(fromSize(size)));
  return box;
};
protoOf(Companion).createGuestBox$default = function (coreServices, id, size, $super) {
  size = size === VOID ? new Vector(200.0, 200.0, 200.0) : size;
  return $super === VOID ? this.a5v(coreServices, id, size) : $super.a5v.call(this, coreServices, id, size);
};
protoOf(Companion).b5v = function (entity) {
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size;
  var size = tmp3_elvis_lhs == null ? __VectorIntConstructorKotlin(200, 200, 200) : tmp3_elvis_lhs;
  // Inline function 'kotlin.arrayOf' call
  var tmp = Companion_instance.l2b_1;
  var tmp_0 = new Transform(new Vector(0.0, 0.0, -size.Z / 2), Companion_getInstance_5().fromEulerDegrees$default(new Degrees(90.0)));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['wall'];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [new PointConnector('toWall', tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, tmp$ret$2)];
  entity.addComponent(new ConnectorsComponent(tmp$ret$5));
};
protoOf(Companion).c5v = function (entity) {
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size;
  var size = tmp3_elvis_lhs == null ? __VectorIntConstructorKotlin(200, 200, 200) : tmp3_elvis_lhs;
  // Inline function 'kotlin.arrayOf' call
  var tmp = Companion_instance.l2b_1;
  var tmp_0 = new Transform(new Vector(0.0, -size.Y / 2, -size.Z / 2), Companion_getInstance_5().fromEulerDegrees$default(new Degrees(45.0)));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['wall-floor-edge'];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [new PointConnector('toWallFloorEdge', tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, tmp$ret$2)];
  entity.addComponent(new ConnectorsComponent(tmp$ret$5));
};
protoOf(Companion).d5v = function (entity) {
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size;
  var axisAlignedCollider = tmp3_elvis_lhs == null ? __VectorIntConstructorKotlin(200, 200, 200) : tmp3_elvis_lhs;
  var previousConnectors = get_connectors(entity);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.arrayOf' call
  var tmp4_type = Companion_instance.n2b_1;
  var tmp5_transform = new Transform(new Vector(axisAlignedCollider.X / 2.0, 0.0, -axisAlignedCollider.Z / 2.0));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp6_demandsArray = ['align'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp7_offersArray = ['align'];
  var tmp = new PointConnector('align right', tmp4_type, tmp5_transform, VOID, VOID, VOID, VOID, tmp7_offersArray, tmp6_demandsArray);
  var tmp8_type = Companion_instance.n2b_1;
  var tmp9_transform = new Transform(new Vector(-axisAlignedCollider.X / 2.0, 0.0, -axisAlignedCollider.Z / 2.0));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp10_demandsArray = ['align'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp11_offersArray = ['align'];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var elements = [tmp, new PointConnector('align left', tmp8_type, tmp9_transform, VOID, VOID, VOID, VOID, tmp11_offersArray, tmp10_demandsArray)];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$16 = previousConnectors.concat(elements);
  entity.addComponent(new ConnectorsComponent(tmp$ret$16));
  return entity;
};
var Companion_instance_5;
function Companion_getInstance_11() {
  if (Companion_instance_5 == null)
    new Companion();
  return Companion_instance_5;
}
function get_snapToFloorTags() {
  return Companion_getInstance_11().z5t_1;
}
function get_snapToFloorDemands() {
  return Companion_getInstance_11().a5u_1;
}
function get_snapToFloorOffers() {
  return Companion_getInstance_11().b5u_1;
}
function get_hostTags() {
  return Companion_getInstance_11().c5u_1;
}
function get_hostOffers() {
  return Companion_getInstance_11().d5u_1;
}
function get_hostDemands() {
  return Companion_getInstance_11().e5u_1;
}
function get_guestOffers() {
  return Companion_getInstance_11().f5u_1;
}
function get_guestDemands() {
  return Companion_getInstance_11().g5u_1;
}
function createConnectedEntities(coreServices) {
  return Companion_getInstance_11().p5u(coreServices);
}
function createEntityWithConnector(type, displayName, coreServices, position, tags, offers, demands, required) {
  return Companion_getInstance_11().q5u(type, displayName, coreServices, position, tags, offers, demands, required);
}
function createEntityWithConnector_0(type, displayName, coreServices, position, tags, offers, demands, required, $super) {
  position = position === VOID ? Companion_getInstance().ZERO : position;
  var tmp;
  if (tags === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tags;
  }
  tags = tmp;
  var tmp_0;
  if (offers === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offers;
  }
  offers = tmp_0;
  var tmp_1;
  if (demands === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demands;
  }
  demands = tmp_1;
  required = required === VOID ? false : required;
  return createEntityWithConnector(type, displayName, coreServices, position, tags, offers, demands, required);
}
function createAssemblyEntityWithChildConnectors(type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required) {
  return Companion_getInstance_11().r5u(type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required);
}
function createAssemblyEntityWithChildConnectors_0(type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required, $super) {
  required = required === VOID ? false : required;
  return createAssemblyEntityWithChildConnectors(type, displayName, leftChildPos, rightChildPos, coreServices, tags, offers, demands, required);
}
function addAssemblyChildWithConnector(type, displayName, entityManager, assembly, childPos, tags, offers, demands, required) {
  return Companion_getInstance_11().s5u(type, displayName, entityManager, assembly, childPos, tags, offers, demands, required);
}
function addAssemblyChildWithConnector_0(type, displayName, entityManager, assembly, childPos, tags, offers, demands, required, $super) {
  required = required === VOID ? false : required;
  return addAssemblyChildWithConnector(type, displayName, entityManager, assembly, childPos, tags, offers, demands, required);
}
function addConnectorToEntity(type, entity, entityManager, connectorLocalPos, tags, offers, demands) {
  return Companion_getInstance_11().t5u(type, entity, entityManager, connectorLocalPos, tags, offers, demands);
}
function addConnectorToEntity_0(type, entity, entityManager, connectorLocalPos, tags, offers, demands, $super) {
  connectorLocalPos = connectorLocalPos === VOID ? Companion_getInstance().ZERO : connectorLocalPos;
  var tmp;
  if (tags === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tags;
  }
  tags = tmp;
  var tmp_0;
  if (offers === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offers;
  }
  offers = tmp_0;
  var tmp_1;
  if (demands === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demands;
  }
  demands = tmp_1;
  return addConnectorToEntity(type, entity, entityManager, connectorLocalPos, tags, offers, demands);
}
function addGroundConnectorToEntity(entity, entityManager) {
  return Companion_getInstance_11().u5u(entity, entityManager);
}
function assertCreatedRequiredHierarchy(host1, host2, guest) {
  return Companion_getInstance_11().v5u(host1, host2, guest);
}
function assertRevertedRequiredHierarchy(host1, host2, oldRequiredParent, room) {
  return Companion_getInstance_11().y5u(host1, host2, oldRequiredParent, room);
}
function hasHostedConnection(host, guest) {
  return Companion_getInstance_11().x5u(host, guest);
}
function hasGuestConnection(host, guest) {
  return Companion_getInstance_11().w5u(host, guest);
}
function createHostWith2Connectors(coreServices, displayName, position) {
  return Companion_getInstance_11().z5u(coreServices, displayName, position);
}
function createHostWith2Connectors_0(coreServices, displayName, position, $super) {
  position = position === VOID ? Companion_getInstance().ZERO : position;
  return createHostWith2Connectors(coreServices, displayName, position);
}
function createGuestBox(coreServices, id, size) {
  return Companion_getInstance_11().a5v(coreServices, id, size);
}
function createGuestBox_0(coreServices, id, size, $super) {
  size = size === VOID ? new Vector(200.0, 200.0, 200.0) : size;
  return createGuestBox(coreServices, id, size);
}
function addWallConnector(entity) {
  return Companion_getInstance_11().b5v(entity);
}
function addFloorEdgeConnector(entity) {
  return Companion_getInstance_11().c5v(entity);
}
function makeAlignable(entity) {
  return Companion_getInstance_11().d5v(entity);
}
function TestEntityFactory() {
  Companion_getInstance_11();
}
function Companion_0() {
}
protoOf(Companion_0).makeAutoAdaptHost = function (_this__u8e3s4, coreServices) {
  return makeAutoAdaptHost_0(_this__u8e3s4, coreServices);
};
protoOf(Companion_0).makeAutoAdaptable = function (_this__u8e3s4, alternativeProductRefs, coreServices) {
  return makeAutoAdaptable_0(_this__u8e3s4, alternativeProductRefs, coreServices);
};
var Companion_instance_6;
function Companion_getInstance_12() {
  return Companion_instance_6;
}
function makeAutoAdaptHost(_this__u8e3s4, coreServices) {
  return Companion_instance_6.makeAutoAdaptHost(_this__u8e3s4, coreServices);
}
function makeAutoAdaptable(_this__u8e3s4, alternativeProductRefs, coreServices) {
  return Companion_instance_6.makeAutoAdaptable(_this__u8e3s4, alternativeProductRefs, coreServices);
}
function AutoAdaptExtensions() {
}
function makeAutoAdaptHost_0(_this__u8e3s4, coreServices) {
  coreServices.entityManager.addComponent(_this__u8e3s4, new AutoAdaptHostComponent(ensureNotNull(get_colliderShapeComponent(_this__u8e3s4)).polyhedron));
}
function makeAutoAdaptable_0(_this__u8e3s4, alternativeProductRefs, coreServices) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [ensureNotNull(get_productRef(_this__u8e3s4))];
  var originalProductRefs = alternativeProductRefs.concat(tmp$ret$3);
  _this__u8e3s4.addComponent(new AutoAdaptGuestComponent(originalProductRefs));
  coreServices.productManager.subscribeProductCreated(makeAutoAdaptable$lambda(originalProductRefs));
}
function makeAutoAdaptable$lambda($originalProductRefs) {
  return function (createdEntity, productRef) {
    var tmp;
    if (!createdEntity.hasComponent(Companion_getInstance_8().id) && contains($originalProductRefs, productRef)) {
      createdEntity.addComponent(new AutoAdaptGuestComponent($originalProductRefs));
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function getProductsInOrderSortedAlongDirection($this, entities, origin, direction) {
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(entities, 10));
  var tmp0_iterator = entities.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.test.helper.placement.Companion.getProductsInOrderSortedAlongDirection.<anonymous>' call
    var weight = positionAlongDirection(Companion_instance_7, get_worldPosition(item), origin, direction);
    var tmp$ret$0 = new ProductWithPositionAlongDirection(item, weight);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = PlaceInLineUtil$Companion$getProductsInOrderSortedAlongDirection$lambda;
  var tmp$ret$3 = new sam$kotlin_Comparator$0(tmp);
  return sortedWith(destination, tmp$ret$3);
}
function ProductWithPositionAlongDirection(entity, position) {
  this.e5v_1 = entity;
  this.f5v_1 = position;
}
protoOf(ProductWithPositionAlongDirection).toString = function () {
  return 'ProductWithPositionAlongDirection(entity=' + this.e5v_1.toString() + ', position=' + this.f5v_1 + ')';
};
protoOf(ProductWithPositionAlongDirection).hashCode = function () {
  var result = this.e5v_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.f5v_1) | 0;
  return result;
};
protoOf(ProductWithPositionAlongDirection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProductWithPositionAlongDirection))
    return false;
  var tmp0_other_with_cast = other instanceof ProductWithPositionAlongDirection ? other : THROW_CCE();
  if (!this.e5v_1.equals(tmp0_other_with_cast.e5v_1))
    return false;
  if (!equals(this.f5v_1, tmp0_other_with_cast.f5v_1))
    return false;
  return true;
};
function isDirectionParallelToAxis($this, vector) {
  var normalized = vector.normalize();
  return normalized.equals(Companion_getInstance().UP) || normalized.equals(Companion_getInstance().DOWN) || normalized.equals(Companion_getInstance().RIGHT) || normalized.equals(Companion_getInstance().LEFT) || normalized.equals(Companion_getInstance().FORWARD) || normalized.equals(Companion_getInstance().BACK);
}
function assertOrderedPlacedOnInterval($this, productsInOrder, coreServices, startPosition, direction) {
  var tmp0_safe_receiver = get_collider(first(productsInOrder).e5v_1);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  var aabb = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var width = aabbSizeAlongDirection($this, aabb, direction);
  var alignWidth = getAlignWidth($this, first(productsInOrder), startPosition, direction);
  var pos = first(productsInOrder).f5v_1;
  var iterator = productsInOrder.k();
  var index = 0;
  while (iterator.m()) {
    var i = index;
    index = index + 1 | 0;
    var product = iterator.n();
    var tmp;
    if (width == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.test.helper.placement.Companion.assertOrderedPlacedOnInterval.<anonymous>' call
      tmp = pos + width * i;
    }
    var expectedBasedOnCollider = tmp;
    var tmp_0;
    if (alignWidth == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.test.helper.placement.Companion.assertOrderedPlacedOnInterval.<anonymous>' call
      tmp_0 = pos + alignWidth * i;
    }
    var expectedBasedOnAlignments = tmp_0;
    var actual = product.f5v_1;
    if (!(expectedBasedOnCollider == null) && !(expectedBasedOnAlignments == null)) {
      // Inline function 'kotlin.math.abs' call
      var x = expectedBasedOnCollider - actual;
      var outcome1 = Math.abs(x) < 0.001;
      // Inline function 'kotlin.math.abs' call
      var x_0 = expectedBasedOnAlignments - actual;
      var outcome2 = Math.abs(x_0) < 0.001;
      if (!outcome1 && !outcome2) {
        // Inline function 'kotlin.error' call
        var message = 'Expect to be equal. Expected: ' + expectedBasedOnCollider + ' (collider) or ' + expectedBasedOnAlignments + ' (alignments) actual: ' + actual;
        throw IllegalStateException_init_$Create$(toString_0(message));
      }
    }
    var entity = product.e5v_1;
    coreServices.entityManager.addComponent(entity, new DisplayNameComponent('Product ' + (i + 1 | 0) + ' ' + get_displayName(entity)));
  }
}
function getAlignWidth($this, productAlongDirection, origin, direction) {
  var entity = productAlongDirection.e5v_1;
  var tmp0_safe_receiver = get_collider(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  var tmp2_elvis_lhs = aabbSizeAlongDirection($this, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox, direction);
  var width = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  var tmp3_safe_receiver = get_connectorsComponent(entity);
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.d2c();
  var alignmentConnectors = tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(alignmentConnectors, 10));
  var tmp0_iterator = alignmentConnectors.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.test.helper.placement.Companion.getAlignWidth.<anonymous>' call
    var tmp$ret$0 = positionAlongDirection(Companion_instance_7, item.getWorldPositionFromOwnerEntity(entity), origin, direction);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var element = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.test.helper.placement.Companion.getAlignWidth.<anonymous>' call
    // Inline function 'kotlin.math.abs' call
    if (Math.abs(element) >= width / 2) {
      destination_0.h(element);
    }
  }
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = PlaceInLineUtil$Companion$getAlignWidth$lambda;
  var tmp$ret$7 = new sam$kotlin_Comparator$0_0(tmp);
  var inOrder = sortedWith(destination_0, tmp$ret$7);
  var tmp_0;
  if (inOrder.o() >= 2) {
    // Inline function 'kotlin.math.abs' call
    var x = first(inOrder) - last(inOrder);
    tmp_0 = Math.abs(x);
  } else {
    tmp_0 = null;
  }
  return tmp_0;
}
function positionAlongDirection($this, position, origin, direction) {
  var normalizedDir = direction.normalize();
  var startToEntity = position.minus(origin);
  var weight = startToEntity.dot(normalizedDir);
  return weight;
}
function aabbSizeAlongDirection($this, axisAlignedBox, direction) {
  if (axisAlignedBox == null)
    return null;
  var tmp;
  // Inline function 'kotlin.math.abs' call
  var x = Companion_getInstance().RIGHT.dot(direction);
  if (Math.abs(x) === 1.0) {
    tmp = axisAlignedBox.width;
  } else {
    // Inline function 'kotlin.math.abs' call
    var x_0 = Companion_getInstance().UP.dot(direction);
    if (Math.abs(x_0) === 1.0) {
      tmp = axisAlignedBox.height;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_1 = Companion_getInstance().FORWARD.dot(direction);
      if (Math.abs(x_1) === 1.0) {
        tmp = axisAlignedBox.depth;
      } else {
        tmp = 0.0;
      }
    }
  }
  return tmp;
}
function sam$kotlin_Comparator$0(function_0) {
  this.g5v_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.g5v_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.g5v_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function sam$kotlin_Comparator$0_0(function_0) {
  this.h5v_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).md = function (a, b) {
  return this.h5v_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).s3 = function () {
  return this.h5v_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.s3());
};
function PlaceInLineUtil$Companion$getProductsInOrderSortedAlongDirection$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.test.helper.placement.Companion.getProductsInOrderSortedAlongDirection.<anonymous>' call
  var tmp = a.f5v_1;
  // Inline function 'com.ikea.core.test.helper.placement.Companion.getProductsInOrderSortedAlongDirection.<anonymous>' call
  var tmp$ret$1 = b.f5v_1;
  return compareValues(tmp, tmp$ret$1);
}
function PlaceInLineUtil$Companion$getAlignWidth$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.test.helper.placement.Companion.getAlignWidth.<anonymous>' call
  var tmp = a;
  // Inline function 'com.ikea.core.test.helper.placement.Companion.getAlignWidth.<anonymous>' call
  return compareValues(tmp, b);
}
function Companion_1() {
}
protoOf(Companion_1).i5v = function (productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction) {
  if (!isDirectionParallelToAxis(this, direction)) {
    // Inline function 'kotlin.error' call
    var message = 'Direction must be parallel to one of the axes';
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  var nextPosition = startPosition;
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, numOfProducts);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.w_1;
  var last = this_0.x_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.placement.Companion.placeProductsInLine.<anonymous>' call
      var tmp0_elvis_lhs = coreServices.productManager.createEntity(productRef);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var message_0 = 'Could not create product ' + productRef;
        throw IllegalStateException_init_$Create$(toString_0(message_0));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var product = tmp;
      product.addComponent(LocalTransformComponentFromPosAndRot(nextPosition, get_localTransform(product).rotation));
      var result = Companion_getInstance_9().s4h(product, coreServices);
      if (!result.valid) {
        // Inline function 'kotlin.error' call
        var message_1 = 'Could not place product: ' + result.toString();
        throw IllegalStateException_init_$Create$(toString_0(message_1));
      }
      nextPosition = get_worldPosition(product).plus(direction);
      if (doAutoAdapt) {
        makeAutoAdaptHost_0(product, coreServices);
      }
      destination.h(product);
    }
     while (!(item === last));
  var products = destination;
  var productsInOrder = getProductsInOrderSortedAlongDirection(this, products, startPosition, direction);
  assertOrderedPlacedOnInterval(this, productsInOrder, coreServices, startPosition, direction);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(productsInOrder, 10));
  var tmp0_iterator = productsInOrder.k();
  while (tmp0_iterator.m()) {
    var item_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.test.helper.placement.Companion.placeProductsInLine.<anonymous>' call
    var tmp$ret$3 = item_0.e5v_1;
    destination_0.h(tmp$ret$3);
  }
  return copyToArray(destination_0);
};
var Companion_instance_7;
function Companion_getInstance_13() {
  return Companion_instance_7;
}
function placeCorrectHeightAboveFloor($this, productEntity) {
  if (get_worldPosition(productEntity).equals(Companion_getInstance().ZERO)) {
    var tmp0_safe_receiver = get_axisAlignedBoundingBoxForHierarchy(productEntity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.height;
    var entityHeight = (tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) / 2;
    var initialPosition = new Vector(0.0, entityHeight, 0.0);
    productEntity.addComponent(LocalTransformComponentFromPosAndRot(initialPosition, get_localTransform(productEntity).rotation));
  }
}
function Companion_2() {
}
protoOf(Companion_2).j5v = function (productRef, coreServices) {
  var result = this.k5v(productRef, coreServices);
  if (!result.valid) {
    // Inline function 'kotlin.error' call
    var message = 'Could not place product: ' + result.toString();
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  var x = ensureNotNull(result.placedEntity);
  var tmp0_elvis_lhs = get_snapRoot(x);
  return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
};
protoOf(Companion_2).l5v = function (productRef, position, coreServices) {
  var result = this.m5v(productRef, position, coreServices);
  if (!result.valid) {
    // Inline function 'kotlin.error' call
    var message = 'Could not place product (' + productRef + ') at ' + position.toString() + ': ' + result.toString();
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  var x = ensureNotNull(result.placedEntity);
  var tmp0_elvis_lhs = get_snapRoot(x);
  return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
};
protoOf(Companion_2).k5v = function (productRef, coreServices) {
  var tmp0_elvis_lhs = coreServices.productManager.createEntity(productRef);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Could not create product ' + productRef;
    throw IllegalStateException_init_$Create$(toString_0(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var productEntity = tmp;
  placeCorrectHeightAboveFloor(this, productEntity);
  return Companion_getInstance_9().s4h(productEntity, coreServices);
};
protoOf(Companion_2).m5v = function (productRef, position, coreServices) {
  var productEntity = coreServices.productManager.createEntity(productRef);
  var tmp;
  if (productEntity == null) {
    var tmp_0 = Companion_instance_4;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [Companion_instance_0.fail('No product found with ref', productRef)];
    tmp = tmp_0.b4i(tmp$ret$2);
  } else {
    tmp = Companion_getInstance_9().r4h(productEntity, position, coreServices);
  }
  return tmp;
};
protoOf(Companion_2).n5v = function (productRef, host, coreServices) {
  var result = this.o5v(productRef, host, coreServices);
  if (!result.valid) {
    // Inline function 'kotlin.error' call
    var message = 'Could not place product (' + productRef + ') in host ' + host.id + ': ' + result.toString();
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  var x = ensureNotNull(result.placedEntity);
  var tmp0_elvis_lhs = get_snapRoot(x);
  return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
};
protoOf(Companion_2).o5v = function (entity, host, coreServices) {
  var productEntity = coreServices.productManager.createEntity(entity);
  var tmp;
  if (productEntity == null) {
    var tmp_0 = Companion_instance_4;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [Companion_instance_0.fail('No product found with ref', entity)];
    tmp = tmp_0.b4i(tmp$ret$2);
  } else {
    placeCorrectHeightAboveFloor(this, productEntity);
    tmp = Companion_getInstance_9().w4h(productEntity, host, coreServices);
  }
  return tmp;
};
protoOf(Companion_2).i5v = function (productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction) {
  return Companion_instance_7.i5v(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction);
};
protoOf(Companion_2).placeProductsInLine$default = function (productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction, $super) {
  doAutoAdapt = doAutoAdapt === VOID ? false : doAutoAdapt;
  startPosition = startPosition === VOID ? Companion_getInstance().ZERO : startPosition;
  direction = direction === VOID ? Companion_getInstance().RIGHT : direction;
  return $super === VOID ? this.i5v(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction) : $super.i5v.call(this, productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction);
};
var Companion_instance_8;
function Companion_getInstance_14() {
  return Companion_instance_8;
}
function createInSceneAndAssert(productRef, coreServices) {
  return Companion_instance_8.j5v(productRef, coreServices);
}
function createAtPositionAndAssert(productRef, position, coreServices) {
  return Companion_instance_8.l5v(productRef, position, coreServices);
}
function createInScene(productRef, coreServices) {
  return Companion_instance_8.k5v(productRef, coreServices);
}
function createAtPosition(productRef, position, coreServices) {
  return Companion_instance_8.m5v(productRef, position, coreServices);
}
function createInHostAndAssert(productRef, host, coreServices) {
  return Companion_instance_8.n5v(productRef, host, coreServices);
}
function createInHost(entity, host, coreServices) {
  return Companion_instance_8.o5v(entity, host, coreServices);
}
function placeProductsInLine(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction) {
  return Companion_instance_8.i5v(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction);
}
function placeProductsInLine_0(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction, $super) {
  doAutoAdapt = doAutoAdapt === VOID ? false : doAutoAdapt;
  startPosition = startPosition === VOID ? Companion_getInstance().ZERO : startPosition;
  direction = direction === VOID ? Companion_getInstance().RIGHT : direction;
  return placeProductsInLine(productRef, numOfProducts, coreServices, doAutoAdapt, startPosition, direction);
}
function TestPlacementUtils() {
}
function Companion_3() {
}
protoOf(Companion_3).createInSceneAndAssert = function (placementService, productRef, coreServices) {
  return Companion_instance_8.j5v(productRef, coreServices);
};
protoOf(Companion_3).createInHostAndAssert = function (_this__u8e3s4, productRef, host, coreServices) {
  return Companion_instance_8.n5v(productRef, host, coreServices);
};
protoOf(Companion_3).createInScene = function (_this__u8e3s4, productRef, coreServices) {
  return Companion_instance_8.k5v(productRef, coreServices);
};
protoOf(Companion_3).createInHost = function (_this__u8e3s4, entity, host, coreServices) {
  return Companion_instance_8.o5v(entity, host, coreServices);
};
protoOf(Companion_3).createAtPosition = function (_this__u8e3s4, entity, position, coreServices) {
  return Companion_instance_8.m5v(entity, position, coreServices);
};
protoOf(Companion_3).createAtPositionAndAssert = function (_this__u8e3s4, productRef, position, coreServices) {
  return Companion_instance_8.l5v(productRef, position, coreServices);
};
protoOf(Companion_3).fillHostWithProduct = function (_this__u8e3s4, productRef, host, coreServices) {
  return fillHostWithProduct_0(_this__u8e3s4, productRef, host, coreServices);
};
var Companion_instance_9;
function Companion_getInstance_15() {
  return Companion_instance_9;
}
function createInSceneAndAssert_0(placementService, productRef, coreServices) {
  return Companion_instance_9.createInSceneAndAssert(placementService, productRef, coreServices);
}
function createInHostAndAssert_0(_this__u8e3s4, productRef, host, coreServices) {
  return Companion_instance_9.createInHostAndAssert(_this__u8e3s4, productRef, host, coreServices);
}
function createInScene_0(_this__u8e3s4, productRef, coreServices) {
  return Companion_instance_9.createInScene(_this__u8e3s4, productRef, coreServices);
}
function createInHost_0(_this__u8e3s4, entity, host, coreServices) {
  return Companion_instance_9.createInHost(_this__u8e3s4, entity, host, coreServices);
}
function createAtPosition_0(_this__u8e3s4, entity, position, coreServices) {
  return Companion_instance_9.createAtPosition(_this__u8e3s4, entity, position, coreServices);
}
function createAtPositionAndAssert_0(_this__u8e3s4, productRef, position, coreServices) {
  return Companion_instance_9.createAtPositionAndAssert(_this__u8e3s4, productRef, position, coreServices);
}
function fillHostWithProduct(_this__u8e3s4, productRef, host, coreServices) {
  return Companion_instance_9.fillHostWithProduct(_this__u8e3s4, productRef, host, coreServices);
}
function PlacementExtensions() {
}
function Companion_4() {
}
protoOf(Companion_4).p5v = function (_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt) {
  return Companion_instance_8.placeProductsInLine$default(productRef, numOfProducts, coreServices, doAutoAdapt);
};
protoOf(Companion_4).placeHostProductsInLine = function (_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt, $super) {
  doAutoAdapt = doAutoAdapt === VOID ? true : doAutoAdapt;
  return $super === VOID ? this.p5v(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt) : $super.p5v.call(this, _this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt);
};
var Companion_instance_10;
function Companion_getInstance_16() {
  return Companion_instance_10;
}
function placeHostProductsInLineJs(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt) {
  return Companion_instance_10.p5v(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt);
}
function placeHostProductsInLine(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt, $super) {
  doAutoAdapt = doAutoAdapt === VOID ? true : doAutoAdapt;
  return placeHostProductsInLineJs(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt);
}
function ArrangeExtensions() {
}
function fillHostWithProduct_0(_this__u8e3s4, productRef, host, coreServices) {
  var valid = true;
  while (valid) {
    var result = Companion_instance_8.o5v(productRef, host, coreServices);
    valid = result.valid;
  }
}
function RemoteConnection() {
}
function enableRemoteViewerJS(coreServices, remoteConnection) {
  enableRemoteViewer(coreServices, remoteConnection);
}
function enableRemoteViewer(coreServices, remoteConnection) {
  remoteConnection = remoteConnection === VOID ? null : remoteConnection;
  if (RemoteViewerState_instance.q5v_1 == null) {
    var baseUrl = 'ws://localhost:8081';
    var remoteConnection_0 = remoteConnection == null ? createWebSocketConnection(baseUrl) : remoteConnection;
    var viewer = new RemoteViewer(baseUrl, coreServices.entityManager, remoteConnection_0);
    var sceneRoot = coreServices.sceneManager.root;
    coreServices.entityManager.addComponent(sceneRoot, new ViewerComponent(viewer));
    RemoteViewerState_instance.q5v_1 = viewer;
  }
}
function nextId($this) {
  var _unary__edvuaz = $this.s5v_1;
  $this.s5v_1 = _unary__edvuaz + 1 | 0;
  return _unary__edvuaz;
}
function createViewerObject($this, id) {
  var objId = id == null ? nextId($this) : id;
  var obj = new RemoteViewerObject(objId, $this.r5v_1, $this.t5v_1, RemoteViewer$createViewerObject$lambda($this, objId));
  while ($this.u5v_1.o() <= objId) {
    $this.u5v_1.h(null);
  }
  $this.u5v_1.n2(objId, obj);
  return obj;
}
function createBoxes($this, entity) {
  var tmp1_safe_receiver = entity == null ? null : get_colliderShapeComponent(entity);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.polyhedron;
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return createBoxes_0($this, tmp2_safe_receiver);
  }
  return tmp;
}
function createBoxes_0($this, colliderPolyhedron) {
  var tmp;
  if (colliderPolyhedron instanceof PolyhedronGroup) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = colliderPolyhedron.polyhedra;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.remoteviewer.RemoteViewer.createBoxes.<anonymous>' call
      var tmp$ret$0 = createBoxes_0($this, item);
      destination.h(tmp$ret$0);
    }
    var children = destination;
    tmp = new ParentNode(children);
  } else {
    var box = Companion_instance_12.w5v(colliderPolyhedron, $this.t5v_1, randomColor($this));
    tmp = box;
  }
  return tmp;
}
function randomColor($this) {
  var letters = '0123456789ABCDEF';
  var color = '#';
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < 6)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.remoteviewer.RemoteViewer.randomColor.<anonymous>' call
      var tmp = color;
      // Inline function 'kotlin.text.random' call
      var tmp$ret$0 = random(letters, Default_getInstance());
      color = tmp + toString_1(tmp$ret$0);
    }
     while (inductionVariable < 6);
  return color;
}
function RemoteViewer$createViewerObject$lambda(this$0, $objId) {
  return function (it) {
    this$0.u5v_1.n2($objId, null);
    return Unit_instance;
  };
}
function RemoteViewer(baseUrl, entityManager, remoteConnection) {
  remoteConnection = remoteConnection === VOID ? createWebSocketConnection(baseUrl) : remoteConnection;
  this.r5v_1 = remoteConnection;
  this.s5v_1 = 1;
  this.t5v_1 = 1000.0;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.u5v_1 = ArrayList_init_$Create$_0();
  this.v5v_1 = new TestRoomRemoteRenderer(this);
  this.v5v_1.l2d(entityManager);
  this.r5v_1.send((new ClearRequest()).y5v());
}
protoOf(RemoteViewer).w32 = function (radius, entity) {
  return createViewerObject(this, null);
};
protoOf(RemoteViewer).x32 = function (vo, entity) {
  return createViewerObject(this, null);
};
protoOf(RemoteViewer).y32 = function (width, height, depth, entity) {
  var id = nextId(this);
  var box = Companion_instance_12.z5v(new Vector(width, height, depth), this.t5v_1, randomColor(this));
  this.r5v_1.send((new CreateBoxRequest(id.toString(), box)).y5v());
  return createViewerObject(this, id);
};
protoOf(RemoteViewer).z32 = function (width, depth, entity) {
  return createViewerObject(this, null);
};
protoOf(RemoteViewer).a33 = function (vertices, normal, entity) {
  return createViewerObject(this, null);
};
protoOf(RemoteViewer).b33 = function (meshes, entity) {
  var id = nextId(this);
  var tmp = id.toString();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(meshes.length);
  var inductionVariable = 0;
  var last = meshes.length;
  while (inductionVariable < last) {
    var item = meshes[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.test.helper.remoteviewer.RemoteViewer.groupMeshes.<anonymous>' call
    var tmp$ret$0 = item.getViewerObjectId().toString();
    destination.h(tmp$ret$0);
  }
  this.r5v_1.send((new GroupMeshesRequest(tmp, destination)).y5v());
  return createViewerObject(this, id);
};
protoOf(RemoteViewer).raycast = function (x, y) {
  return null;
};
protoOf(RemoteViewer).worldCoordToCanvas = function (x, y, z) {
  return null;
};
protoOf(RemoteViewer).c33 = function (start, end, color, thickness) {
  return 0;
};
protoOf(RemoteViewer).d33 = function (start, end, color, thickness) {
  return 0;
};
protoOf(RemoteViewer).e33 = function (id, start, end, color, thickness) {
};
protoOf(RemoteViewer).removeUiLine = function (id) {
};
protoOf(RemoteViewer).uiLineExists = function (id) {
  return false;
};
protoOf(RemoteViewer).f33 = function (entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter) {
  var id = nextId(this);
  var collider = createBoxes(this, entity);
  this.r5v_1.send((new LoadModelRequest(id.toString(), url, collider)).y5v());
  return createViewerObject(this, id);
};
protoOf(RemoteViewer).existsModel = function (objId) {
  return !(getOrNull(this.u5v_1, objId) == null);
};
protoOf(RemoteViewer).resize = function () {
};
protoOf(RemoteViewer).g33 = function (enable) {
};
protoOf(RemoteViewer).h33 = function (entity) {
  return createViewerObject(this, null);
};
protoOf(RemoteViewer).i33 = function (modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize) {
};
function RemoteViewerState() {
  this.q5v_1 = null;
}
var RemoteViewerState_instance;
function RemoteViewerState_getInstance() {
  return RemoteViewerState_instance;
}
function RemoteViewerObject(id, remoteConnection, remoteViewerScale, onDelete) {
  this.a5w_1 = id;
  this.b5w_1 = remoteConnection;
  this.c5w_1 = remoteViewerScale;
  this.d5w_1 = onDelete;
  this.e5w_1 = Companion_getInstance().ZERO;
  this.f5w_1 = Companion_getInstance_5().q2b_1;
  this.g5w_1 = false;
}
protoOf(RemoteViewerObject).getViewerObjectId = function () {
  return this.a5w_1;
};
protoOf(RemoteViewerObject).setPosition = function (vector) {
  this.e5w_1 = vector.div(this.c5w_1);
  this.b5w_1.send((new SetPositionRequest(this.a5w_1.toString(), toPosition(this.e5w_1))).y5v());
  return this;
};
protoOf(RemoteViewerObject).getPosition = function () {
  return this.e5w_1;
};
protoOf(RemoteViewerObject).setRotation = function (q) {
  this.f5w_1 = q;
  this.b5w_1.send((new SetRotationRequest(this.a5w_1.toString(), toDTO(this.f5w_1))).y5v());
  return this;
};
protoOf(RemoteViewerObject).getRotation = function () {
  return this.f5w_1;
};
protoOf(RemoteViewerObject).setRotationEulerAngleDegrees = function (v) {
  return this.setRotation(Companion_getInstance_5().fromEulerDegreesVector(v));
};
protoOf(RemoteViewerObject).setScale = function (x, y, z) {
  return this;
};
protoOf(RemoteViewerObject).getScale = function () {
  return Companion_getInstance().ONE;
};
protoOf(RemoteViewerObject).setOutlined = function (outlined) {
  return this;
};
protoOf(RemoteViewerObject).setBlockOutlined = function (blockOutlined) {
  return this;
};
protoOf(RemoteViewerObject).setBaseColor = function (r, g, b) {
  return this;
};
protoOf(RemoteViewerObject).setTransparency = function (alpha) {
  return this;
};
protoOf(RemoteViewerObject).setReceiveShadows = function (receiveShadows) {
  return this;
};
protoOf(RemoteViewerObject).setCastShadows = function (castShadows) {
  return this;
};
protoOf(RemoteViewerObject).setParent = function (parentMesh) {
  return this;
};
protoOf(RemoteViewerObject).setVisible = function (visible) {
  return this;
};
protoOf(RemoteViewerObject).getVisible = function () {
  return true;
};
protoOf(RemoteViewerObject).setEnabled = function (enabled) {
};
protoOf(RemoteViewerObject).isEnabled = function () {
  return true;
};
protoOf(RemoteViewerObject).deleteObject = function () {
  this.b5w_1.send((new DeleteRequest(this.a5w_1.toString())).y5v());
  this.d5w_1(this.getViewerObjectId());
};
protoOf(RemoteViewerObject).makeClickable = function (onClick) {
};
protoOf(RemoteViewerObject).registerInputEvents = function () {
};
protoOf(RemoteViewerObject).unregisterInputEvents = function () {
};
protoOf(RemoteViewerObject).n33 = function () {
  return this.g5w_1;
};
protoOf(RemoteViewerObject).setOutlinedObjectColor = function (r, g, b) {
  return this;
};
protoOf(RemoteViewerObject).removeOutlinedObjectColor = function () {
  return this;
};
function Companion_5() {
}
var Companion_instance_11;
function Companion_getInstance_17() {
  return Companion_instance_11;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.ClearRequest', this, 1);
  tmp0_serialDesc.lw('cmd', false);
  this.h5w_1 = tmp0_serialDesc;
}
protoOf($serializer).i5w = function (encoder, value) {
  var tmp0_desc = this.h5w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer).ul = function (encoder, value) {
  return this.i5w(encoder, value instanceof ClearRequest ? value : THROW_CCE());
};
protoOf($serializer).vl = function (decoder) {
  var tmp0_desc = this.h5w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return ClearRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).tl = function () {
  return this.h5w_1;
};
protoOf($serializer).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ClearRequest_init_$Init$(seen0, cmd, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().h5w_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  return $this;
}
function ClearRequest_init_$Create$(seen0, cmd, serializationConstructorMarker) {
  return ClearRequest_init_$Init$(seen0, cmd, serializationConstructorMarker, objectCreate(protoOf(ClearRequest)));
}
function ClearRequest() {
  Request.call(this, 'clear');
}
function Companion_6() {
}
protoOf(Companion_6).w5v = function (polyhedron, scale, color) {
  var aabb = polyhedron.axisAlignedBoundingBox;
  var center = aabb.center.div(scale);
  var size = aabb.size.div(scale);
  return new Box(toPosition(center), SizeFromVector(size), color);
};
protoOf(Companion_6).z5v = function (size, scale, color) {
  var scaledSize = size.div(scale);
  return new Box(toPosition(Companion_getInstance().ZERO), SizeFromVector(scaledSize), color);
};
var Companion_instance_12;
function Companion_getInstance_18() {
  return Companion_instance_12;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.Box', this, 3);
  tmp0_serialDesc.lw('position', false);
  tmp0_serialDesc.lw('dimension', false);
  tmp0_serialDesc.lw('color', false);
  this.j5w_1 = tmp0_serialDesc;
}
protoOf($serializer_0).k5w = function (encoder, value) {
  var tmp0_desc = this.j5w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_7(), value.l5w_1);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance(), value.m5w_1);
  tmp1_output.qq(tmp0_desc, 2, value.n5w_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_0).ul = function (encoder, value) {
  return this.k5w(encoder, value instanceof Box ? value : THROW_CCE());
};
protoOf($serializer_0).vl = function (decoder) {
  var tmp0_desc = this.j5w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.np(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.np(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return Box_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_0).tl = function () {
  return this.j5w_1;
};
protoOf($serializer_0).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_7(), $serializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function Box_init_$Init$(seen0, position, dimension, color, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_1().j5w_1);
  }
  $this.l5w_1 = position;
  $this.m5w_1 = dimension;
  $this.n5w_1 = color;
  return $this;
}
function Box_init_$Create$(seen0, position, dimension, color, serializationConstructorMarker) {
  return Box_init_$Init$(seen0, position, dimension, color, serializationConstructorMarker, objectCreate(protoOf(Box)));
}
function Box(position, dimension, color) {
  this.l5w_1 = position;
  this.m5w_1 = dimension;
  this.n5w_1 = color;
}
protoOf(Box).toString = function () {
  return 'Box(position=' + this.l5w_1.toString() + ', dimension=' + this.m5w_1.toString() + ', color=' + this.n5w_1 + ')';
};
protoOf(Box).hashCode = function () {
  var result = this.l5w_1.hashCode();
  result = imul(result, 31) + this.m5w_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.n5w_1) | 0;
  return result;
};
protoOf(Box).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Box))
    return false;
  var tmp0_other_with_cast = other instanceof Box ? other : THROW_CCE();
  if (!this.l5w_1.equals(tmp0_other_with_cast.l5w_1))
    return false;
  if (!this.m5w_1.equals(tmp0_other_with_cast.m5w_1))
    return false;
  if (!(this.n5w_1 === tmp0_other_with_cast.n5w_1))
    return false;
  return true;
};
function Companion_7() {
}
var Companion_instance_13;
function Companion_getInstance_19() {
  return Companion_instance_13;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.CreateBoxRequest', this, 3);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('box', false);
  this.o5w_1 = tmp0_serialDesc;
}
protoOf($serializer_1).p5w = function (encoder, value) {
  var tmp0_desc = this.o5w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.r5w_1);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_1(), value.s5w_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_1).ul = function (encoder, value) {
  return this.p5w(encoder, value instanceof CreateBoxRequest ? value : THROW_CCE());
};
protoOf($serializer_1).vl = function (decoder) {
  var tmp0_desc = this.o5w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return CreateBoxRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_1).tl = function () {
  return this.o5w_1;
};
protoOf($serializer_1).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_1()];
};
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function CreateBoxRequest_init_$Init$(seen0, cmd, id, box, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_2().o5w_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.r5w_1 = id;
  $this.s5w_1 = box;
  return $this;
}
function CreateBoxRequest_init_$Create$(seen0, cmd, id, box, serializationConstructorMarker) {
  return CreateBoxRequest_init_$Init$(seen0, cmd, id, box, serializationConstructorMarker, objectCreate(protoOf(CreateBoxRequest)));
}
function CreateBoxRequest(id, box) {
  Request.call(this, 'createBox');
  this.r5w_1 = id;
  this.s5w_1 = box;
}
protoOf(CreateBoxRequest).toString = function () {
  return 'CreateBoxRequest(id=' + this.r5w_1 + ', box=' + this.s5w_1.toString() + ')';
};
protoOf(CreateBoxRequest).hashCode = function () {
  var result = getStringHashCode(this.r5w_1);
  result = imul(result, 31) + this.s5w_1.hashCode() | 0;
  return result;
};
protoOf(CreateBoxRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CreateBoxRequest))
    return false;
  var tmp0_other_with_cast = other instanceof CreateBoxRequest ? other : THROW_CCE();
  if (!(this.r5w_1 === tmp0_other_with_cast.r5w_1))
    return false;
  if (!this.s5w_1.equals(tmp0_other_with_cast.s5w_1))
    return false;
  return true;
};
function Companion_8() {
  Companion_instance_14 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.t5w_1 = [null, null, new ArrayListSerializer(StringSerializer_getInstance())];
}
var Companion_instance_14;
function Companion_getInstance_20() {
  if (Companion_instance_14 == null)
    new Companion_8();
  return Companion_instance_14;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.GroupMeshesRequest', this, 3);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('boxIds', false);
  this.u5w_1 = tmp0_serialDesc;
}
protoOf($serializer_2).v5w = function (encoder, value) {
  var tmp0_desc = this.u5w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_20().t5w_1;
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.x5w_1);
  tmp1_output.sq(tmp0_desc, 2, tmp2_cached[2], value.y5w_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_2).ul = function (encoder, value) {
  return this.v5w(encoder, value instanceof GroupMeshesRequest ? value : THROW_CCE());
};
protoOf($serializer_2).vl = function (decoder) {
  var tmp0_desc = this.u5w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  var tmp8_cached = Companion_getInstance_20().t5w_1;
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return GroupMeshesRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_2).tl = function () {
  return this.u5w_1;
};
protoOf($serializer_2).ex = function () {
  var tmp0_cached = Companion_getInstance_20().t5w_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2]];
};
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function GroupMeshesRequest_init_$Init$(seen0, cmd, id, boxIds, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_3().u5w_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.x5w_1 = id;
  $this.y5w_1 = boxIds;
  return $this;
}
function GroupMeshesRequest_init_$Create$(seen0, cmd, id, boxIds, serializationConstructorMarker) {
  return GroupMeshesRequest_init_$Init$(seen0, cmd, id, boxIds, serializationConstructorMarker, objectCreate(protoOf(GroupMeshesRequest)));
}
function GroupMeshesRequest(id, boxIds) {
  Companion_getInstance_20();
  Request.call(this, 'groupMeshes');
  this.x5w_1 = id;
  this.y5w_1 = boxIds;
}
protoOf(GroupMeshesRequest).toString = function () {
  return 'GroupMeshesRequest(id=' + this.x5w_1 + ', boxIds=' + toString_0(this.y5w_1) + ')';
};
protoOf(GroupMeshesRequest).hashCode = function () {
  var result = getStringHashCode(this.x5w_1);
  result = imul(result, 31) + hashCode(this.y5w_1) | 0;
  return result;
};
protoOf(GroupMeshesRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GroupMeshesRequest))
    return false;
  var tmp0_other_with_cast = other instanceof GroupMeshesRequest ? other : THROW_CCE();
  if (!(this.x5w_1 === tmp0_other_with_cast.x5w_1))
    return false;
  if (!equals(this.y5w_1, tmp0_other_with_cast.y5w_1))
    return false;
  return true;
};
function Companion_9() {
}
protoOf(Companion_9).z18 = function () {
  var tmp = getKClass(Node);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Box), getKClass(ParentNode)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_1(), $serializer_getInstance_4()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer_init_$Create$('com.ikea.core.test.helper.remoteviewer.Node', tmp, tmp_0, tmp_1, tmp$ret$8);
};
protoOf(Companion_9).rx = function (typeParamsSerializers) {
  return this.z18();
};
var Companion_instance_15;
function Companion_getInstance_21() {
  return Companion_instance_15;
}
function Node() {
}
function Companion_10() {
  Companion_instance_16 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  var tmp_0 = getKClass(Node);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [getKClass(Box), getKClass(ParentNode)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [$serializer_getInstance_1(), $serializer_getInstance_4()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.z5w_1 = [new ArrayListSerializer(SealedClassSerializer_init_$Create$('com.ikea.core.test.helper.remoteviewer.Node', tmp_0, tmp_1, tmp_2, tmp$ret$8))];
}
var Companion_instance_16;
function Companion_getInstance_22() {
  if (Companion_instance_16 == null)
    new Companion_10();
  return Companion_instance_16;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.ParentNode', this, 1);
  tmp0_serialDesc.lw('children', false);
  this.a5x_1 = tmp0_serialDesc;
}
protoOf($serializer_3).b5x = function (encoder, value) {
  var tmp0_desc = this.a5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_22().z5w_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.c5x_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_3).ul = function (encoder, value) {
  return this.b5x(encoder, value instanceof ParentNode ? value : THROW_CCE());
};
protoOf($serializer_3).vl = function (decoder) {
  var tmp0_desc = this.a5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  var tmp6_cached = Companion_getInstance_22().z5w_1;
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return ParentNode_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_3).tl = function () {
  return this.a5x_1;
};
protoOf($serializer_3).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_22().z5w_1[0]];
};
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ParentNode_init_$Init$(seen0, children, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_4().a5x_1);
  }
  $this.c5x_1 = children;
  return $this;
}
function ParentNode_init_$Create$(seen0, children, serializationConstructorMarker) {
  return ParentNode_init_$Init$(seen0, children, serializationConstructorMarker, objectCreate(protoOf(ParentNode)));
}
function ParentNode(children) {
  Companion_getInstance_22();
  this.c5x_1 = children;
}
protoOf(ParentNode).toString = function () {
  return 'ParentNode(children=' + toString_0(this.c5x_1) + ')';
};
protoOf(ParentNode).hashCode = function () {
  return hashCode(this.c5x_1);
};
protoOf(ParentNode).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ParentNode))
    return false;
  var tmp0_other_with_cast = other instanceof ParentNode ? other : THROW_CCE();
  if (!equals(this.c5x_1, tmp0_other_with_cast.c5x_1))
    return false;
  return true;
};
function Companion_11() {
  Companion_instance_17 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  var tmp_0 = getKClass(Node);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [getKClass(Box), getKClass(ParentNode)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [$serializer_getInstance_1(), $serializer_getInstance_4()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d5x_1 = [null, null, null, SealedClassSerializer_init_$Create$('com.ikea.core.test.helper.remoteviewer.Node', tmp_0, tmp_1, tmp_2, tmp$ret$8)];
}
var Companion_instance_17;
function Companion_getInstance_23() {
  if (Companion_instance_17 == null)
    new Companion_11();
  return Companion_instance_17;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.LoadModelRequest', this, 4);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('modelUrl', false);
  tmp0_serialDesc.lw('collider', false);
  this.e5x_1 = tmp0_serialDesc;
}
protoOf($serializer_4).f5x = function (encoder, value) {
  var tmp0_desc = this.e5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_23().d5x_1;
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.h5x_1);
  tmp1_output.qq(tmp0_desc, 2, value.i5x_1);
  tmp1_output.uq(tmp0_desc, 3, tmp2_cached[3], value.j5x_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_4).ul = function (encoder, value) {
  return this.f5x(encoder, value instanceof LoadModelRequest ? value : THROW_CCE());
};
protoOf($serializer_4).vl = function (decoder) {
  var tmp0_desc = this.e5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.bp(tmp0_desc);
  var tmp9_cached = Companion_getInstance_23().d5x_1;
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.pp(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.pp(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return LoadModelRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_4).tl = function () {
  return this.e5x_1;
};
protoOf($serializer_4).ex = function () {
  var tmp0_cached = Companion_getInstance_23().d5x_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[3])];
};
var $serializer_instance_4;
function $serializer_getInstance_5() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function LoadModelRequest_init_$Init$(seen0, cmd, id, modelUrl, collider, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_5().e5x_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.h5x_1 = id;
  $this.i5x_1 = modelUrl;
  $this.j5x_1 = collider;
  return $this;
}
function LoadModelRequest_init_$Create$(seen0, cmd, id, modelUrl, collider, serializationConstructorMarker) {
  return LoadModelRequest_init_$Init$(seen0, cmd, id, modelUrl, collider, serializationConstructorMarker, objectCreate(protoOf(LoadModelRequest)));
}
function LoadModelRequest(id, modelUrl, collider) {
  Companion_getInstance_23();
  Request.call(this, 'loadModel');
  this.h5x_1 = id;
  this.i5x_1 = modelUrl;
  this.j5x_1 = collider;
}
protoOf(LoadModelRequest).toString = function () {
  return 'LoadModelRequest(id=' + this.h5x_1 + ', modelUrl=' + this.i5x_1 + ', collider=' + toString(this.j5x_1) + ')';
};
protoOf(LoadModelRequest).hashCode = function () {
  var result = getStringHashCode(this.h5x_1);
  result = imul(result, 31) + getStringHashCode(this.i5x_1) | 0;
  result = imul(result, 31) + (this.j5x_1 == null ? 0 : hashCode(this.j5x_1)) | 0;
  return result;
};
protoOf(LoadModelRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoadModelRequest))
    return false;
  var tmp0_other_with_cast = other instanceof LoadModelRequest ? other : THROW_CCE();
  if (!(this.h5x_1 === tmp0_other_with_cast.h5x_1))
    return false;
  if (!(this.i5x_1 === tmp0_other_with_cast.i5x_1))
    return false;
  if (!equals(this.j5x_1, tmp0_other_with_cast.j5x_1))
    return false;
  return true;
};
function Companion_12() {
}
var Companion_instance_18;
function Companion_getInstance_24() {
  return Companion_instance_18;
}
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.SetPositionRequest', this, 3);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('position', false);
  this.k5x_1 = tmp0_serialDesc;
}
protoOf($serializer_5).l5x = function (encoder, value) {
  var tmp0_desc = this.k5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.n5x_1);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_7(), value.o5x_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_5).ul = function (encoder, value) {
  return this.l5x(encoder, value instanceof SetPositionRequest ? value : THROW_CCE());
};
protoOf($serializer_5).vl = function (decoder) {
  var tmp0_desc = this.k5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return SetPositionRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_5).tl = function () {
  return this.k5x_1;
};
protoOf($serializer_5).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_7()];
};
var $serializer_instance_5;
function $serializer_getInstance_6() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function SetPositionRequest_init_$Init$(seen0, cmd, id, position, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_6().k5x_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.n5x_1 = id;
  $this.o5x_1 = position;
  return $this;
}
function SetPositionRequest_init_$Create$(seen0, cmd, id, position, serializationConstructorMarker) {
  return SetPositionRequest_init_$Init$(seen0, cmd, id, position, serializationConstructorMarker, objectCreate(protoOf(SetPositionRequest)));
}
function SetPositionRequest(id, position) {
  Request.call(this, 'setPosition');
  this.n5x_1 = id;
  this.o5x_1 = position;
}
protoOf(SetPositionRequest).toString = function () {
  return 'SetPositionRequest(id=' + this.n5x_1 + ', position=' + this.o5x_1.toString() + ')';
};
protoOf(SetPositionRequest).hashCode = function () {
  var result = getStringHashCode(this.n5x_1);
  result = imul(result, 31) + this.o5x_1.hashCode() | 0;
  return result;
};
protoOf(SetPositionRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetPositionRequest))
    return false;
  var tmp0_other_with_cast = other instanceof SetPositionRequest ? other : THROW_CCE();
  if (!(this.n5x_1 === tmp0_other_with_cast.n5x_1))
    return false;
  if (!this.o5x_1.equals(tmp0_other_with_cast.o5x_1))
    return false;
  return true;
};
function Companion_13() {
}
var Companion_instance_19;
function Companion_getInstance_25() {
  return Companion_instance_19;
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.Position', this, 3);
  tmp0_serialDesc.lw('x', false);
  tmp0_serialDesc.lw('y', false);
  tmp0_serialDesc.lw('z', false);
  this.p5x_1 = tmp0_serialDesc;
}
protoOf($serializer_6).q5x = function (encoder, value) {
  var tmp0_desc = this.p5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.oq(tmp0_desc, 0, value.r5x_1);
  tmp1_output.oq(tmp0_desc, 1, value.s5x_1);
  tmp1_output.oq(tmp0_desc, 2, value.t5x_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_6).ul = function (encoder, value) {
  return this.q5x(encoder, value instanceof Position ? value : THROW_CCE());
};
protoOf($serializer_6).vl = function (decoder) {
  var tmp0_desc = this.p5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return Position_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_6).tl = function () {
  return this.p5x_1;
};
protoOf($serializer_6).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance_6;
function $serializer_getInstance_7() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function Position_init_$Init$(seen0, x, y, z, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_7().p5x_1);
  }
  $this.r5x_1 = x;
  $this.s5x_1 = y;
  $this.t5x_1 = z;
  return $this;
}
function Position_init_$Create$(seen0, x, y, z, serializationConstructorMarker) {
  return Position_init_$Init$(seen0, x, y, z, serializationConstructorMarker, objectCreate(protoOf(Position)));
}
function Position(x, y, z) {
  this.r5x_1 = x;
  this.s5x_1 = y;
  this.t5x_1 = z;
}
protoOf(Position).toString = function () {
  return 'Position(x=' + this.r5x_1 + ', y=' + this.s5x_1 + ', z=' + this.t5x_1 + ')';
};
protoOf(Position).hashCode = function () {
  var result = getNumberHashCode(this.r5x_1);
  result = imul(result, 31) + getNumberHashCode(this.s5x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.t5x_1) | 0;
  return result;
};
protoOf(Position).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Position))
    return false;
  var tmp0_other_with_cast = other instanceof Position ? other : THROW_CCE();
  if (!equals(this.r5x_1, tmp0_other_with_cast.r5x_1))
    return false;
  if (!equals(this.s5x_1, tmp0_other_with_cast.s5x_1))
    return false;
  if (!equals(this.t5x_1, tmp0_other_with_cast.t5x_1))
    return false;
  return true;
};
function toPosition(_this__u8e3s4) {
  return new Position(_this__u8e3s4.X, _this__u8e3s4.Y, _this__u8e3s4.Z);
}
function Companion_14() {
}
var Companion_instance_20;
function Companion_getInstance_26() {
  return Companion_instance_20;
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.SetRotationRequest', this, 3);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('rotation', false);
  this.u5x_1 = tmp0_serialDesc;
}
protoOf($serializer_7).v5x = function (encoder, value) {
  var tmp0_desc = this.u5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.x5x_1);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_9(), value.y5x_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_7).ul = function (encoder, value) {
  return this.v5x(encoder, value instanceof SetRotationRequest ? value : THROW_CCE());
};
protoOf($serializer_7).vl = function (decoder) {
  var tmp0_desc = this.u5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_9(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, $serializer_getInstance_9(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return SetRotationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_7).tl = function () {
  return this.u5x_1;
};
protoOf($serializer_7).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_9()];
};
var $serializer_instance_7;
function $serializer_getInstance_8() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function SetRotationRequest_init_$Init$(seen0, cmd, id, rotation, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_8().u5x_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.x5x_1 = id;
  $this.y5x_1 = rotation;
  return $this;
}
function SetRotationRequest_init_$Create$(seen0, cmd, id, rotation, serializationConstructorMarker) {
  return SetRotationRequest_init_$Init$(seen0, cmd, id, rotation, serializationConstructorMarker, objectCreate(protoOf(SetRotationRequest)));
}
function SetRotationRequest(id, rotation) {
  Request.call(this, 'setRotation');
  this.x5x_1 = id;
  this.y5x_1 = rotation;
}
protoOf(SetRotationRequest).toString = function () {
  return 'SetRotationRequest(id=' + this.x5x_1 + ', rotation=' + this.y5x_1.toString() + ')';
};
protoOf(SetRotationRequest).hashCode = function () {
  var result = getStringHashCode(this.x5x_1);
  result = imul(result, 31) + this.y5x_1.hashCode() | 0;
  return result;
};
protoOf(SetRotationRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetRotationRequest))
    return false;
  var tmp0_other_with_cast = other instanceof SetRotationRequest ? other : THROW_CCE();
  if (!(this.x5x_1 === tmp0_other_with_cast.x5x_1))
    return false;
  if (!this.y5x_1.equals(tmp0_other_with_cast.y5x_1))
    return false;
  return true;
};
function Companion_15() {
}
var Companion_instance_21;
function Companion_getInstance_27() {
  return Companion_instance_21;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.QuaternionDTO', this, 4);
  tmp0_serialDesc.lw('x', false);
  tmp0_serialDesc.lw('y', false);
  tmp0_serialDesc.lw('z', false);
  tmp0_serialDesc.lw('w', false);
  this.z5x_1 = tmp0_serialDesc;
}
protoOf($serializer_8).a5y = function (encoder, value) {
  var tmp0_desc = this.z5x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.oq(tmp0_desc, 0, value.b5y_1);
  tmp1_output.oq(tmp0_desc, 1, value.c5y_1);
  tmp1_output.oq(tmp0_desc, 2, value.d5y_1);
  tmp1_output.oq(tmp0_desc, 3, value.e5y_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_8).ul = function (encoder, value) {
  return this.a5y(encoder, value instanceof QuaternionDTO ? value : THROW_CCE());
};
protoOf($serializer_8).vl = function (decoder) {
  var tmp0_desc = this.z5x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_input = decoder.bp(tmp0_desc);
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.jp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.jp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return QuaternionDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_8).tl = function () {
  return this.z5x_1;
};
protoOf($serializer_8).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance_8;
function $serializer_getInstance_9() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function QuaternionDTO_init_$Init$(seen0, x, y, z, w, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_9().z5x_1);
  }
  $this.b5y_1 = x;
  $this.c5y_1 = y;
  $this.d5y_1 = z;
  $this.e5y_1 = w;
  return $this;
}
function QuaternionDTO_init_$Create$(seen0, x, y, z, w, serializationConstructorMarker) {
  return QuaternionDTO_init_$Init$(seen0, x, y, z, w, serializationConstructorMarker, objectCreate(protoOf(QuaternionDTO)));
}
function QuaternionDTO(x, y, z, w) {
  this.b5y_1 = x;
  this.c5y_1 = y;
  this.d5y_1 = z;
  this.e5y_1 = w;
}
protoOf(QuaternionDTO).toString = function () {
  return 'QuaternionDTO(x=' + this.b5y_1 + ', y=' + this.c5y_1 + ', z=' + this.d5y_1 + ', w=' + this.e5y_1 + ')';
};
protoOf(QuaternionDTO).hashCode = function () {
  var result = getNumberHashCode(this.b5y_1);
  result = imul(result, 31) + getNumberHashCode(this.c5y_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d5y_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.e5y_1) | 0;
  return result;
};
protoOf(QuaternionDTO).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof QuaternionDTO))
    return false;
  var tmp0_other_with_cast = other instanceof QuaternionDTO ? other : THROW_CCE();
  if (!equals(this.b5y_1, tmp0_other_with_cast.b5y_1))
    return false;
  if (!equals(this.c5y_1, tmp0_other_with_cast.c5y_1))
    return false;
  if (!equals(this.d5y_1, tmp0_other_with_cast.d5y_1))
    return false;
  if (!equals(this.e5y_1, tmp0_other_with_cast.e5y_1))
    return false;
  return true;
};
function toDTO(_this__u8e3s4) {
  return new QuaternionDTO(_this__u8e3s4.x, _this__u8e3s4.y, _this__u8e3s4.z, _this__u8e3s4.w);
}
function Companion_16() {
}
var Companion_instance_22;
function Companion_getInstance_28() {
  return Companion_instance_22;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.remoteviewer.DeleteRequest', this, 2);
  tmp0_serialDesc.lw('cmd', false);
  tmp0_serialDesc.lw('id', false);
  this.f5y_1 = tmp0_serialDesc;
}
protoOf($serializer_9).g5y = function (encoder, value) {
  var tmp0_desc = this.f5y_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.x5v_1);
  tmp1_output.qq(tmp0_desc, 1, value.i5y_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_9).ul = function (encoder, value) {
  return this.g5y(encoder, value instanceof DeleteRequest ? value : THROW_CCE());
};
protoOf($serializer_9).vl = function (decoder) {
  var tmp0_desc = this.f5y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return DeleteRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_9).tl = function () {
  return this.f5y_1;
};
protoOf($serializer_9).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_9;
function $serializer_getInstance_10() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function DeleteRequest_init_$Init$(seen0, cmd, id, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_10().f5y_1);
  }
  Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this);
  $this.i5y_1 = id;
  return $this;
}
function DeleteRequest_init_$Create$(seen0, cmd, id, serializationConstructorMarker) {
  return DeleteRequest_init_$Init$(seen0, cmd, id, serializationConstructorMarker, objectCreate(protoOf(DeleteRequest)));
}
function DeleteRequest(id) {
  Request.call(this, 'delete');
  this.i5y_1 = id;
}
protoOf(DeleteRequest).toString = function () {
  return 'DeleteRequest(id=' + this.i5y_1 + ')';
};
protoOf(DeleteRequest).hashCode = function () {
  return getStringHashCode(this.i5y_1);
};
protoOf(DeleteRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DeleteRequest))
    return false;
  var tmp0_other_with_cast = other instanceof DeleteRequest ? other : THROW_CCE();
  if (!(this.i5y_1 === tmp0_other_with_cast.i5y_1))
    return false;
  return true;
};
function _get_$cachedSerializer__te6jhj($this) {
  return $this.j5y_1.c2();
}
function Request$Companion$_anonymous__dysha8() {
  var tmp = getKClass(Request);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(ClearRequest), getKClass(CreateBoxRequest), getKClass(DeleteRequest), getKClass(GroupMeshesRequest), getKClass(LoadModelRequest), getKClass(SetPositionRequest), getKClass(SetRotationRequest)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_0(), $serializer_getInstance_2(), $serializer_getInstance_10(), $serializer_getInstance_3(), $serializer_getInstance_5(), $serializer_getInstance_6(), $serializer_getInstance_8()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer_init_$Create$('com.ikea.core.test.helper.remoteviewer.Request', tmp, tmp_0, tmp_1, tmp$ret$8);
}
function Companion_17() {
  Companion_instance_23 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.j5y_1 = lazy(tmp_0, Request$Companion$_anonymous__dysha8);
}
protoOf(Companion_17).z18 = function () {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_17).rx = function (typeParamsSerializers) {
  return this.z18();
};
var Companion_instance_23;
function Companion_getInstance_29() {
  if (Companion_instance_23 == null)
    new Companion_17();
  return Companion_instance_23;
}
function Request_init_$Init$(seen0, cmd, serializationConstructorMarker, $this) {
  $this.x5v_1 = cmd;
  return $this;
}
function Request(cmd) {
  Companion_getInstance_29();
  this.x5v_1 = cmd;
}
protoOf(Request).y5v = function () {
  return Default_getInstance_0().v16(Companion_getInstance_29().z18(), this);
};
function removeOldBox($this, entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_instance_1.n1s());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if ($this.t5y_1.existsModel(tmp0_safe_receiver.viewerObject.getViewerObjectId())) {
      tmp0_safe_receiver.viewerObject.deleteObject();
    }
  }
}
function createBox_0($this, roomPart) {
  var tmp0_safe_receiver = get_collider(roomPart);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var aabb = tmp;
  var viewerObject = $this.t5y_1.createBox(aabb.width, aabb.height, aabb.depth, roomPart);
  viewerObject.setPosition(aabb.center);
  roomPart.addComponent(new ViewerObjectComponent(viewerObject));
}
function TestRoomRemoteRenderer(viewer) {
  var tmp = Companion_getInstance_6().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_getInstance_10().id];
  SystemBase.call(this, 'TestRoomHttpRenderer', tmp, VOID, VOID, VOID, tmp$ret$2);
  this.t5y_1 = viewer;
  this.enable();
}
protoOf(TestRoomRemoteRenderer).u5y = function (entity, newComponent) {
  createBox_0(this, entity);
};
protoOf(TestRoomRemoteRenderer).v1v = function (entity, newComponent) {
  return this.u5y(entity, newComponent instanceof ColliderComponent ? newComponent : THROW_CCE());
};
protoOf(TestRoomRemoteRenderer).v5y = function (entity, oldComponent, newComponent) {
  removeOldBox(this, entity);
  createBox_0(this, entity);
};
protoOf(TestRoomRemoteRenderer).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColliderComponent ? oldComponent : THROW_CCE();
  return this.v5y(entity, tmp, newComponent instanceof ColliderComponent ? newComponent : THROW_CCE());
};
protoOf(TestRoomRemoteRenderer).w5y = function (entity, oldComponent) {
  removeOldBox(this, entity);
};
protoOf(TestRoomRemoteRenderer).z1v = function (entity, oldComponent) {
  return this.w5y(entity, oldComponent instanceof ColliderComponent ? oldComponent : THROW_CCE());
};
function Companion_18() {
  this.x5y_1 = 'ctr-90214563';
  this.y5y_1 = 'ctr-00214572';
  this.z5y_1 = 'ctr-50214560';
  this.a5z_1 = 'ctr-20214566';
  this.b5z_1 = 'cax-frame-offset-bounds';
  this.c5z_1 = 'ctr-80214568';
  this.d5z_1 = 'ctr-40214565';
  this.e5z_1 = 'ctr-70214559';
  this.f5z_1 = 'ctr-80207493';
  this.g5z_1 = 'ctr-70214564';
}
protoOf(Companion_18).h5z = function () {
  return this.x5y_1;
};
protoOf(Companion_18).i5z = function () {
  return this.y5y_1;
};
protoOf(Companion_18).j5z = function () {
  return this.z5y_1;
};
protoOf(Companion_18).k5z = function () {
  return this.a5z_1;
};
protoOf(Companion_18).l5z = function () {
  return this.b5z_1;
};
protoOf(Companion_18).m5z = function () {
  return this.c5z_1;
};
protoOf(Companion_18).n5z = function () {
  return this.d5z_1;
};
protoOf(Companion_18).o5z = function () {
  return this.e5z_1;
};
protoOf(Companion_18).p5z = function () {
  return this.f5z_1;
};
protoOf(Companion_18).q5z = function () {
  return this.g5z_1;
};
var Companion_instance_24;
function Companion_getInstance_30() {
  return Companion_instance_24;
}
function get_d100x35x201() {
  return Companion_instance_24.x5y_1;
}
function get_d100x35x236() {
  return Companion_instance_24.y5y_1;
}
function get_d100x58x236() {
  return Companion_instance_24.z5y_1;
}
function get_d100x58x201() {
  return Companion_instance_24.a5z_1;
}
function get_d100x58x201_with_offset_bounds() {
  return Companion_instance_24.b5z_1;
}
function get_d50x58x236() {
  return Companion_instance_24.c5z_1;
}
function get_d50x35x236() {
  return Companion_instance_24.d5z_1;
}
function get_d50x58x201() {
  return Companion_instance_24.e5z_1;
}
function get_d75x35x236() {
  return Companion_instance_24.f5z_1;
}
function get_d75x58x201() {
  return Companion_instance_24.g5z_1;
}
function Companion_19() {
  this.r5z_1 = 'ctr-40346938';
  this.s5z_1 = 'ctr-30346934';
}
protoOf(Companion_19).t5z = function () {
  return this.r5z_1;
};
protoOf(Companion_19).m5z = function () {
  return this.s5z_1;
};
var Companion_instance_25;
function Companion_getInstance_31() {
  return Companion_instance_25;
}
function get_d50x35x201() {
  return Companion_instance_25.r5z_1;
}
function get_d50x58x236_0() {
  return Companion_instance_25.s5z_1;
}
function Companion_20() {
  this.u5z_1 = 'ctr-40346938-frame';
  this.v5z_1 = 'ctr-30346934-frame';
}
protoOf(Companion_20).t5z = function () {
  return this.u5z_1;
};
protoOf(Companion_20).m5z = function () {
  return this.v5z_1;
};
var Companion_instance_26;
function Companion_getInstance_32() {
  return Companion_instance_26;
}
function get_d50x35x201_0() {
  return Companion_instance_26.u5z_1;
}
function get_d50x58x236_1() {
  return Companion_instance_26.v5z_1;
}
function Companion_21() {
  this.w5z_1 = 'ctr-90214563-40346938-asm';
  this.x5z_1 = 'ctr-00214572-30346934-asm';
  this.y5z_1 = 'ctr-20214566-40346938-asm';
}
protoOf(Companion_21).z5z = function () {
  return this.w5z_1;
};
protoOf(Companion_21).a60 = function () {
  return this.x5z_1;
};
protoOf(Companion_21).b60 = function () {
  return this.y5z_1;
};
var Companion_instance_27;
function Companion_getInstance_33() {
  return Companion_instance_27;
}
function get_d100x35x210_35_left() {
  return Companion_instance_27.w5z_1;
}
function get_d100x35x236_58_left() {
  return Companion_instance_27.x5z_1;
}
function get_d100x58x210_35_left() {
  return Companion_instance_27.y5z_1;
}
function Companion_22() {
  this.c60_1 = 'SPR-29332075';
}
protoOf(Companion_22).d60 = function () {
  return this.c60_1;
};
var Companion_instance_28;
function Companion_getInstance_34() {
  return Companion_instance_28;
}
function get_d100x58() {
  return Companion_instance_28.c60_1;
}
function Companion_23() {
  this.e60_1 = 'ctr-S89010982';
  this.f60_1 = 'ctr-S29010980';
  this.g60_1 = 'ctr-S49010979';
}
protoOf(Companion_23).h60 = function () {
  return this.e60_1;
};
protoOf(Companion_23).d60 = function () {
  return this.f60_1;
};
protoOf(Companion_23).i60 = function () {
  return this.g60_1;
};
var Companion_instance_29;
function Companion_getInstance_35() {
  return Companion_instance_29;
}
function get_d100x35() {
  return Companion_instance_29.e60_1;
}
function get_d100x58_0() {
  return Companion_instance_29.f60_1;
}
function get_d50x58() {
  return Companion_instance_29.g60_1;
}
function Companion_24() {
  this.j60_1 = 'ctr-40257296';
  this.k60_1 = 'ctr-00257298';
}
protoOf(Companion_24).l60 = function () {
  return this.j60_1;
};
protoOf(Companion_24).m60 = function () {
  return this.k60_1;
};
var Companion_instance_30;
function Companion_getInstance_36() {
  return Companion_instance_30;
}
function get_d100x58_GRAY() {
  return Companion_instance_30.j60_1;
}
function get_d100x58_WHITE() {
  return Companion_instance_30.k60_1;
}
function Companion_25() {
  this.n60_1 = 'ctr-10273504';
  this.o60_1 = 'ctr-10277984';
  this.p60_1 = 'ctr-50273502';
  this.q60_1 = 'ctr-50277977';
  this.r60_1 = 'ctr-80273505';
  this.s60_1 = 'ctr-70277981';
  this.t60_1 = 'ctr-40277992';
}
protoOf(Companion_25).h60 = function () {
  return this.n60_1;
};
protoOf(Companion_25).d60 = function () {
  return this.o60_1;
};
protoOf(Companion_25).u60 = function () {
  return this.p60_1;
};
protoOf(Companion_25).v60 = function () {
  return this.q60_1;
};
protoOf(Companion_25).w60 = function () {
  return this.r60_1;
};
protoOf(Companion_25).i60 = function () {
  return this.s60_1;
};
protoOf(Companion_25).x60 = function () {
  return this.t60_1;
};
var Companion_instance_31;
function Companion_getInstance_37() {
  return Companion_instance_31;
}
function get_d100x35_0() {
  return Companion_instance_31.n60_1;
}
function get_d100x58_1() {
  return Companion_instance_31.o60_1;
}
function get_d75x35() {
  return Companion_instance_31.p60_1;
}
function get_d75x58() {
  return Companion_instance_31.q60_1;
}
function get_d50x35() {
  return Companion_instance_31.r60_1;
}
function get_d50x58_0() {
  return Companion_instance_31.s60_1;
}
function get_d50x35_WHITE() {
  return Companion_instance_31.t60_1;
}
function Companion_26() {
  this.y60_1 = 'ctr-90257251';
}
protoOf(Companion_26).h60 = function () {
  return this.y60_1;
};
var Companion_instance_32;
function Companion_getInstance_38() {
  return Companion_instance_32;
}
function get_d100x35_1() {
  return Companion_instance_32.y60_1;
}
function Companion_27() {
  this.z60_1 = 'ctr-60272837';
  this.a61_1 = 'ctr-20272839';
  this.b61_1 = 'ctr-70246348';
  this.c61_1 = 'ctr-50246306';
}
protoOf(Companion_27).h60 = function () {
  return this.z60_1;
};
protoOf(Companion_27).w60 = function () {
  return this.a61_1;
};
protoOf(Companion_27).d60 = function () {
  return this.b61_1;
};
protoOf(Companion_27).i60 = function () {
  return this.c61_1;
};
var Companion_instance_33;
function Companion_getInstance_39() {
  return Companion_instance_33;
}
function get_d100x35_2() {
  return Companion_instance_33.z60_1;
}
function get_d50x35_0() {
  return Companion_instance_33.a61_1;
}
function get_d100x58_2() {
  return Companion_instance_33.b61_1;
}
function get_d50x58_1() {
  return Companion_instance_33.c61_1;
}
function Companion_28() {
  Companion_instance_34 = this;
  this.d61_1 = 'ctr-S80329197_ASM';
  this.e61_1 = 'ctr-S20329195_ASM';
  this.f61_1 = 'ctr-S20414829_ASM';
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g61_1 = [this.d61_1, this.e61_1, this.f61_1];
}
protoOf(Companion_28).h61 = function () {
  return this.d61_1;
};
protoOf(Companion_28).i61 = function () {
  return this.e61_1;
};
protoOf(Companion_28).j61 = function () {
  return this.f61_1;
};
protoOf(Companion_28).k61 = function () {
  return this.g61_1;
};
var Companion_instance_34;
function Companion_getInstance_40() {
  if (Companion_instance_34 == null)
    new Companion_28();
  return Companion_instance_34;
}
function get_d50x236() {
  return Companion_getInstance_40().d61_1;
}
function get_d50x201() {
  return Companion_getInstance_40().e61_1;
}
function get_d25x201() {
  return Companion_getInstance_40().f61_1;
}
function get_doorsOfAllSizes() {
  return Companion_getInstance_40().g61_1;
}
function Companion_29() {
  this.l61_1 = 'ctr-80329197';
  this.m61_1 = 'ctr-20329195';
  this.n61_1 = 'ctr-00343989';
}
protoOf(Companion_29).h61 = function () {
  return this.l61_1;
};
protoOf(Companion_29).i61 = function () {
  return this.m61_1;
};
protoOf(Companion_29).o61 = function () {
  return this.n61_1;
};
var Companion_instance_35;
function Companion_getInstance_41() {
  return Companion_instance_35;
}
function get_d50x236_0() {
  return Companion_instance_35.l61_1;
}
function get_d50x201_0() {
  return Companion_instance_35.m61_1;
}
function get_d50x201otherColor() {
  return Companion_instance_35.n61_1;
}
function Companion_30() {
  this.p61_1 = 'ctr-80256940';
  this.q61_1 = 'ctr-40256942';
  this.r61_1 = 'ctr-30446467';
}
protoOf(Companion_30).d60 = function () {
  return this.p61_1;
};
protoOf(Companion_30).i60 = function () {
  return this.q61_1;
};
protoOf(Companion_30).h60 = function () {
  return this.r61_1;
};
var Companion_instance_36;
function Companion_getInstance_42() {
  return Companion_instance_36;
}
function get_d100x58_3() {
  return Companion_instance_36.p61_1;
}
function get_d50x58_2() {
  return Companion_instance_36.q61_1;
}
function get_d100x35_3() {
  return Companion_instance_36.r61_1;
}
function Companion_31() {
  this.s61_1 = 'ctr-60257182';
}
protoOf(Companion_31).t61 = function () {
  return this.s61_1;
};
var Companion_instance_37;
function Companion_getInstance_43() {
  return Companion_instance_37;
}
function get_white() {
  return Companion_instance_37.s61_1;
}
function Companion_32() {
  this.u61_1 = 'ctr-40246420';
}
protoOf(Companion_32).d60 = function () {
  return this.u61_1;
};
var Companion_instance_38;
function Companion_getInstance_44() {
  return Companion_instance_38;
}
function get_d100x58_4() {
  return Companion_instance_38.u61_1;
}
function Companion_33() {
  this.v61_1 = 'ctr-50437565';
  this.w61_1 = 'ctr-50437565-mirrored';
  this.x61_1 = 'ctr-20246402';
  this.y61_1 = 'ctr-20246402-mirrored';
}
protoOf(Companion_33).z61 = function () {
  return this.v61_1;
};
protoOf(Companion_33).a62 = function () {
  return this.w61_1;
};
protoOf(Companion_33).b62 = function () {
  return this.x61_1;
};
protoOf(Companion_33).c62 = function () {
  return this.y61_1;
};
var Companion_instance_39;
function Companion_getInstance_45() {
  return Companion_instance_39;
}
function get_right35() {
  return Companion_instance_39.v61_1;
}
function get_left35() {
  return Companion_instance_39.w61_1;
}
function get_right58() {
  return Companion_instance_39.x61_1;
}
function get_left58() {
  return Companion_instance_39.y61_1;
}
function Companion_34() {
  Companion_instance_40 = this;
  this.d62_1 = 'ctr-SPR-89177986_V2';
  this.e62_1 = 'ctr-SPR-69178005_V2';
  this.f62_1 = 'ctr-SPR-29178007_V2';
  this.g62_1 = 'ctr-SPR-89178009_V2';
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.h62_1 = [this.d62_1, this.e62_1, this.f62_1, this.g62_1];
}
protoOf(Companion_34).i62 = function () {
  return this.d62_1;
};
protoOf(Companion_34).j62 = function () {
  return this.e62_1;
};
protoOf(Companion_34).k62 = function () {
  return this.f62_1;
};
protoOf(Companion_34).l62 = function () {
  return this.g62_1;
};
protoOf(Companion_34).k61 = function () {
  return this.h62_1;
};
var Companion_instance_40;
function Companion_getInstance_46() {
  if (Companion_instance_40 == null)
    new Companion_34();
  return Companion_instance_40;
}
function get_slidingDoor150x201() {
  return Companion_getInstance_46().d62_1;
}
function get_slidingDoor150x236() {
  return Companion_getInstance_46().e62_1;
}
function get_slidingDoor200x201() {
  return Companion_getInstance_46().f62_1;
}
function get_slidingDoor200x236() {
  return Companion_getInstance_46().g62_1;
}
function get_doorsOfAllSizes_0() {
  return Companion_getInstance_46().h62_1;
}
function Companion_35() {
  this.m62_1 = 'ctr-00116699';
  this.n62_1 = 'ctr-20348896';
  this.o62_1 = 'ctr-20404665';
}
protoOf(Companion_35).p62 = function () {
  return this.m62_1;
};
protoOf(Companion_35).q62 = function () {
  return this.n62_1;
};
protoOf(Companion_35).r62 = function () {
  return this.o62_1;
};
var Companion_instance_41;
function Companion_getInstance_47() {
  return Companion_instance_41;
}
function get_vinna357Stainless() {
  return Companion_instance_41.m62_1;
}
function get_osternasAlwaysHangDownHandle() {
  return Companion_instance_41.n62_1;
}
function get_longLongHandle() {
  return Companion_instance_41.o62_1;
}
function Companion_36() {
  this.s62_1 = 'ctr-SPR-59332069';
}
protoOf(Companion_36).t62 = function () {
  return this.s62_1;
};
var Companion_instance_42;
function Companion_getInstance_48() {
  return Companion_instance_42;
}
function get_shoeInserts100x58() {
  return Companion_instance_42.s62_1;
}
function Companion_37() {
  this.u62_1 = 'ctr-30405565-900x530';
  this.v62_1 = 'ctr-30405565-450x530';
}
protoOf(Companion_37).w62 = function () {
  return this.u62_1;
};
protoOf(Companion_37).x62 = function () {
  return this.v62_1;
};
var Companion_instance_43;
function Companion_getInstance_49() {
  return Companion_instance_43;
}
function get_mat100x58() {
  return Companion_instance_43.u62_1;
}
function get_mat50x58() {
  return Companion_instance_43.v62_1;
}
function Companion_38() {
  this.y62_1 = 'ctr-S79260844';
  this.z62_1 = 'ctr-S99260838';
}
protoOf(Companion_38).a63 = function () {
  return this.y62_1;
};
protoOf(Companion_38).b63 = function () {
  return this.z62_1;
};
var Companion_instance_44;
function Companion_getInstance_50() {
  return Companion_instance_44;
}
function get_boxSet100x58() {
  return Companion_instance_44.y62_1;
}
function get_boxSet50x58() {
  return Companion_instance_44.z62_1;
}
function Companion_39() {
  this.c63_1 = 'ctr-70257186';
  this.d63_1 = 'ctr-20262487';
}
protoOf(Companion_39).e63 = function () {
  return this.c63_1;
};
protoOf(Companion_39).f63 = function () {
  return this.d63_1;
};
var Companion_instance_45;
function Companion_getInstance_51() {
  return Companion_instance_45;
}
function get_d35() {
  return Companion_instance_45.c63_1;
}
function get_d58() {
  return Companion_instance_45.d63_1;
}
function Companion_40() {
  this.g63_1 = 'ctr-interior-suggestion-for-cax-frame-100x58';
  this.h63_1 = 'ctr-interior-suggestion-2-for-cax-frame-100x58';
}
protoOf(Companion_40).i63 = function () {
  return this.g63_1;
};
protoOf(Companion_40).j63 = function () {
  return this.h63_1;
};
var Companion_instance_46;
function Companion_getInstance_52() {
  return Companion_instance_46;
}
function get_cax1() {
  return Companion_instance_46.g63_1;
}
function get_cax2() {
  return Companion_instance_46.h63_1;
}
function Companion_41() {
  this.k63_1 = 'ctr-10260436';
  this.l63_1 = 'ctr-20332254';
  this.m63_1 = 'ctr-90332255';
}
protoOf(Companion_41).n63 = function () {
  return this.k63_1;
};
protoOf(Companion_41).o63 = function () {
  return this.l63_1;
};
protoOf(Companion_41).p63 = function () {
  return this.m63_1;
};
var Companion_instance_47;
function Companion_getInstance_53() {
  return Companion_instance_47;
}
function get_outer() {
  return Companion_instance_47.k63_1;
}
function get_inner67() {
  return Companion_instance_47.l63_1;
}
function get_inner92() {
  return Companion_instance_47.m63_1;
}
function Companion_42() {
  this.q63_1 = 'ctr-60400000';
  this.r63_1 = 'ctr-20399999';
}
protoOf(Companion_42).d60 = function () {
  return this.q63_1;
};
protoOf(Companion_42).i60 = function () {
  return this.r63_1;
};
var Companion_instance_48;
function Companion_getInstance_54() {
  return Companion_instance_48;
}
function get_d100x58_5() {
  return Companion_instance_48.q63_1;
}
function get_d50x58_3() {
  return Companion_instance_48.r63_1;
}
function Companion_43() {
  this.s63_1 = 'frame-with-interiors-spr-example-product';
}
protoOf(Companion_43).t63 = function () {
  return this.s63_1;
};
var Companion_instance_49;
function Companion_getInstance_55() {
  return Companion_instance_49;
}
function get_frameWithInteriors() {
  return Companion_instance_49.s63_1;
}
function Companion_44() {
  this.u63_1 = 'sliding-door-group-4x50-SPR';
  this.v63_1 = 'sliding-door-group-2x100-SPR';
  this.w63_1 = 'two-frames-flat-product-structure';
  this.x63_1 = 'two-two-frames-flat-product-structure';
  this.y63_1 = 'two-frames-flat-product-structure-with-transform';
  this.z63_1 = 'two-frames-flat-product-structure-one-frame-missing';
  this.a64_1 = 'cesta-2-frames-w-top-panel-product';
  this.b64_1 = 'four-frames-flat-product-structure-with-snap-and-transform';
}
protoOf(Companion_44).c64 = function () {
  return this.u63_1;
};
protoOf(Companion_44).d64 = function () {
  return this.v63_1;
};
protoOf(Companion_44).e64 = function () {
  return this.w63_1;
};
protoOf(Companion_44).f64 = function () {
  return this.x63_1;
};
protoOf(Companion_44).g64 = function () {
  return this.y63_1;
};
protoOf(Companion_44).h64 = function () {
  return this.z63_1;
};
protoOf(Companion_44).i64 = function () {
  return this.a64_1;
};
protoOf(Companion_44).j64 = function () {
  return this.b64_1;
};
var Companion_instance_50;
function Companion_getInstance_56() {
  return Companion_instance_50;
}
function get_slidingDoor4x50x201() {
  return Companion_instance_50.u63_1;
}
function get_slidingDoor2x100x201() {
  return Companion_instance_50.v63_1;
}
function get_flatProductStructure() {
  return Companion_instance_50.w63_1;
}
function get_deepFlatProductStructure() {
  return Companion_instance_50.x63_1;
}
function get_flatProductStructureWithTransform() {
  return Companion_instance_50.y63_1;
}
function get_flatProductStructureMissingPart() {
  return Companion_instance_50.z63_1;
}
function get_framesWithTopPanel() {
  return Companion_instance_50.a64_1;
}
function get_flatProductStructureWithSnapAndTransform() {
  return Companion_instance_50.b64_1;
}
function Frame() {
}
function CornerFrameWithShelvesProductStructure() {
}
function CornerAddonFrame() {
}
function CornerSolutions() {
}
function ShoeTrayAssembly() {
}
function MeshBasketAssembly() {
}
function MeshBasketBasket() {
}
function Shelf() {
}
function ShoeShelf() {
}
function Drawer() {
}
function DoorAssembly() {
  Companion_getInstance_40();
}
function DoorFront() {
}
function ClothesRails() {
}
function ValetHanger() {
}
function TDivider() {
}
function LDivider() {
}
function SlidingDoor() {
  Companion_getInstance_46();
}
function Handle() {
}
function PullOutTrayWithInserts() {
}
function DrawerMat() {
}
function KompBoxSet() {
}
function PullOutMultiUseHanger() {
}
function InteriorSuggestion() {
}
function Light() {
}
function ShelfBox() {
}
function FrameWithInteriors() {
}
function ProductStructure() {
}
function Companion_45() {
  Companion_instance_51 = this;
  this.k64_1 = Companion_instance_36;
  this.l64_1 = Companion_instance_27;
  this.m64_1 = Companion_instance_25;
  this.n64_1 = Companion_instance_26;
  this.o64_1 = Companion_getInstance_40();
  this.p64_1 = Companion_instance_35;
  this.q64_1 = Companion_instance_33;
  this.r64_1 = Companion_instance_24;
  this.s64_1 = Companion_instance_41;
  this.t64_1 = Companion_instance_39;
  this.u64_1 = Companion_instance_29;
  this.v64_1 = Companion_instance_30;
  this.w64_1 = Companion_instance_42;
  this.x64_1 = Companion_instance_31;
  this.y64_1 = Companion_instance_32;
  this.z64_1 = Companion_getInstance_46();
  this.a65_1 = Companion_instance_38;
  this.b65_1 = Companion_instance_37;
  this.c65_1 = Companion_instance_44;
  this.d65_1 = Companion_instance_43;
  this.e65_1 = Companion_instance_45;
  this.f65_1 = Companion_instance_46;
  this.g65_1 = Companion_instance_47;
  this.h65_1 = Companion_instance_48;
  this.i65_1 = Companion_instance_49;
  this.j65_1 = Companion_instance_50;
  this.k65_1 = Companion_instance_28;
}
protoOf(Companion_45).l65 = function () {
  return this.k64_1;
};
protoOf(Companion_45).m65 = function () {
  return this.l64_1;
};
protoOf(Companion_45).n65 = function () {
  return this.m64_1;
};
protoOf(Companion_45).o65 = function () {
  return this.n64_1;
};
protoOf(Companion_45).p65 = function () {
  return this.o64_1;
};
protoOf(Companion_45).q65 = function () {
  return this.p64_1;
};
protoOf(Companion_45).r65 = function () {
  return this.q64_1;
};
protoOf(Companion_45).s65 = function () {
  return this.r64_1;
};
protoOf(Companion_45).u5k = function () {
  return this.s64_1;
};
protoOf(Companion_45).t65 = function () {
  return this.t64_1;
};
protoOf(Companion_45).u65 = function () {
  return this.u64_1;
};
protoOf(Companion_45).v65 = function () {
  return this.v64_1;
};
protoOf(Companion_45).w65 = function () {
  return this.w64_1;
};
protoOf(Companion_45).x65 = function () {
  return this.x64_1;
};
protoOf(Companion_45).y65 = function () {
  return this.y64_1;
};
protoOf(Companion_45).z65 = function () {
  return this.z64_1;
};
protoOf(Companion_45).a66 = function () {
  return this.a65_1;
};
protoOf(Companion_45).b66 = function () {
  return this.b65_1;
};
protoOf(Companion_45).c66 = function () {
  return this.c65_1;
};
protoOf(Companion_45).d66 = function () {
  return this.d65_1;
};
protoOf(Companion_45).e66 = function () {
  return this.e65_1;
};
protoOf(Companion_45).f66 = function () {
  return this.f65_1;
};
protoOf(Companion_45).g66 = function () {
  return this.g65_1;
};
protoOf(Companion_45).h66 = function () {
  return this.h65_1;
};
protoOf(Companion_45).i66 = function () {
  return this.i65_1;
};
protoOf(Companion_45).j66 = function () {
  return this.j65_1;
};
protoOf(Companion_45).k66 = function () {
  return this.k65_1;
};
var Companion_instance_51;
function Companion_getInstance_57() {
  if (Companion_instance_51 == null)
    new Companion_45();
  return Companion_instance_51;
}
function get_clothesRails() {
  return Companion_getInstance_57().k64_1;
}
function get_cornerSolutions() {
  return Companion_getInstance_57().l64_1;
}
function get_cornerAddonFrameWithShelvesProductStructure() {
  return Companion_getInstance_57().m64_1;
}
function get_cornerAddonFrames() {
  return Companion_getInstance_57().n64_1;
}
function get_doors() {
  return Companion_getInstance_57().o64_1;
}
function get_doorFronts() {
  return Companion_getInstance_57().p64_1;
}
function get_drawers() {
  return Companion_getInstance_57().q64_1;
}
function get_frames() {
  return Companion_getInstance_57().r64_1;
}
function get_handle() {
  return Companion_getInstance_57().s64_1;
}
function get_lDivider() {
  return Companion_getInstance_57().t64_1;
}
function get_meshBaskets() {
  return Companion_getInstance_57().u64_1;
}
function get_meshBasketBaskets() {
  return Companion_getInstance_57().v64_1;
}
function get_pullOutTraysWithInserts() {
  return Companion_getInstance_57().w64_1;
}
function get_shelves() {
  return Companion_getInstance_57().x64_1;
}
function get_shoeShelves() {
  return Companion_getInstance_57().y64_1;
}
function get_slidingDoor() {
  return Companion_getInstance_57().z64_1;
}
function get_tDivider() {
  return Companion_getInstance_57().a65_1;
}
function get_valetHanger() {
  return Companion_getInstance_57().b65_1;
}
function get_kompBoxSet() {
  return Companion_getInstance_57().c65_1;
}
function get_drawerMat() {
  return Companion_getInstance_57().d65_1;
}
function get_pullOutMultiUseHanger() {
  return Companion_getInstance_57().e65_1;
}
function get_interiorSuggestions() {
  return Companion_getInstance_57().f65_1;
}
function get_lights() {
  return Companion_getInstance_57().g65_1;
}
function get_shelfBoxes() {
  return Companion_getInstance_57().h65_1;
}
function get_framesWithInteriors() {
  return Companion_getInstance_57().i65_1;
}
function get_productStructures() {
  return Companion_getInstance_57().j65_1;
}
function get_shoeTrayAssembly() {
  return Companion_getInstance_57().k65_1;
}
function Companion_46() {
  this.l66_1 = 'ctr-80247413_ASM';
  this.m66_1 = 'ctr-40245840_ASM';
  this.n66_1 = 'ctr-70245848_ASM';
  this.o66_1 = 'ctr-30247378_ASM';
  this.p66_1 = 'ctr-00245917_ASM';
}
protoOf(Companion_46).q66 = function () {
  return this.l66_1;
};
protoOf(Companion_46).r66 = function () {
  return this.m66_1;
};
protoOf(Companion_46).s66 = function () {
  return this.n66_1;
};
protoOf(Companion_46).t66 = function () {
  return this.o66_1;
};
protoOf(Companion_46).u66 = function () {
  return this.p66_1;
};
var Companion_instance_52;
function Companion_getInstance_58() {
  return Companion_instance_52;
}
function get_d60x20x64() {
  return Companion_instance_52.l66_1;
}
function get_d60x40x128() {
  return Companion_instance_52.m66_1;
}
function get_d60x40x38() {
  return Companion_instance_52.n66_1;
}
function get_d60x40x38wood() {
  return Companion_instance_52.o66_1;
}
function get_d60x20x38() {
  return Companion_instance_52.p66_1;
}
function Companion_47() {
  this.v66_1 = 'ctr-80247413';
  this.w66_1 = 'ctr-40245840';
  this.x66_1 = 'ctr-70245848';
  this.y66_1 = 'ctr-30247378';
  this.z66_1 = 'ctr-00245917';
}
protoOf(Companion_47).q66 = function () {
  return this.v66_1;
};
protoOf(Companion_47).r66 = function () {
  return this.w66_1;
};
protoOf(Companion_47).s66 = function () {
  return this.x66_1;
};
protoOf(Companion_47).t66 = function () {
  return this.y66_1;
};
protoOf(Companion_47).u66 = function () {
  return this.z66_1;
};
var Companion_instance_53;
function Companion_getInstance_59() {
  return Companion_instance_53;
}
function get_d60x20x64_0() {
  return Companion_instance_53.v66_1;
}
function get_d60x40x128_0() {
  return Companion_instance_53.w66_1;
}
function get_d60x40x38_0() {
  return Companion_instance_53.x66_1;
}
function get_d60x40x38wood_0() {
  return Companion_instance_53.y66_1;
}
function get_d60x20x38_0() {
  return Companion_instance_53.z66_1;
}
function Companion_48() {
  this.a67_1 = 'ctr-S60291845_ASM';
  this.b67_1 = 'ctr-S00291848_ASM';
}
protoOf(Companion_48).c67 = function () {
  return this.a67_1;
};
protoOf(Companion_48).d67 = function () {
  return this.b67_1;
};
var Companion_instance_54;
function Companion_getInstance_60() {
  return Companion_instance_54;
}
function get_d60x64() {
  return Companion_instance_54.a67_1;
}
function get_d60x38() {
  return Companion_instance_54.b67_1;
}
function Companion_49() {
  this.e67_1 = 'ctr-00361087';
  this.f67_1 = 'ctr-10291683';
}
protoOf(Companion_49).d67 = function () {
  return this.e67_1;
};
protoOf(Companion_49).g67 = function () {
  return this.f67_1;
};
var Companion_instance_55;
function Companion_getInstance_61() {
  return Companion_instance_55;
}
function get_d60x38_0() {
  return Companion_instance_55.e67_1;
}
function get_d60x38wood() {
  return Companion_instance_55.f67_1;
}
function Companion_50() {
  this.h67_1 = 'ctr-S00361087-hsc_ASM';
}
protoOf(Companion_50).i67 = function () {
  return this.h67_1;
};
var Companion_instance_56;
function Companion_getInstance_62() {
  return Companion_instance_56;
}
function get_d60x38_softclosing() {
  return Companion_instance_56.h67_1;
}
function Companion_51() {
  this.j67_1 = 'ctr-80351517';
  this.k67_1 = 'ctr-60351518';
}
protoOf(Companion_51).d67 = function () {
  return this.j67_1;
};
protoOf(Companion_51).g67 = function () {
  return this.k67_1;
};
var Companion_instance_57;
function Companion_getInstance_63() {
  return Companion_instance_57;
}
function get_d60x38_1() {
  return Companion_instance_57.j67_1;
}
function get_d60x38wood_0() {
  return Companion_instance_57.k67_1;
}
function Companion_52() {
  this.l67_1 = 'ctr-10293564';
  this.m67_1 = 'ctr-20293568';
  this.n67_1 = 'ctr-pFramePad';
}
protoOf(Companion_52).o67 = function () {
  return this.l67_1;
};
protoOf(Companion_52).p67 = function () {
  return this.m67_1;
};
protoOf(Companion_52).q67 = function () {
  return this.n67_1;
};
var Companion_instance_58;
function Companion_getInstance_64() {
  return Companion_instance_58;
}
function get_d10_STUBBARP() {
  return Companion_instance_58.l67_1;
}
function get_mergableLeg() {
  return Companion_instance_58.m67_1;
}
function get_framePad() {
  return Companion_instance_58.n67_1;
}
function Companion_53() {
  this.r67_1 = 'ctr-20295548';
  this.s67_1 = 'ctr-00295549';
}
protoOf(Companion_53).t67 = function () {
  return this.r67_1;
};
protoOf(Companion_53).u67 = function () {
  return this.s67_1;
};
var Companion_instance_59;
function Companion_getInstance_65() {
  return Companion_instance_59;
}
function get_d60x20() {
  return Companion_instance_59.r67_1;
}
function get_d60x40() {
  return Companion_instance_59.s67_1;
}
function Companion_54() {
  this.v67_1 = 'ctr-30196538';
}
protoOf(Companion_54).w67 = function () {
  return this.v67_1;
};
var Companion_instance_60;
function Companion_getInstance_66() {
  return Companion_instance_60;
}
function get_d120x40() {
  return Companion_instance_60.v67_1;
}
function Companion_55() {
  this.x67_1 = 'ctr-00347888';
}
protoOf(Companion_55).y67 = function () {
  return this.x67_1;
};
var Companion_instance_61;
function Companion_getInstance_67() {
  return Companion_instance_61;
}
function get_edvalla_hanging() {
  return Companion_instance_61.x67_1;
}
function Companion_56() {
  this.z67_1 = 'ctr-cesta-20348896';
}
protoOf(Companion_56).a68 = function () {
  return this.z67_1;
};
var Companion_instance_62;
function Companion_getInstance_68() {
  return Companion_instance_62;
}
function get_osternas_hanging() {
  return Companion_instance_62.z67_1;
}
function Companion_57() {
  this.b68_1 = 'Cesta point series product structure';
  this.c68_1 = 'cesta-2-frames-w-top-panel-product';
}
protoOf(Companion_57).d68 = function () {
  return this.b68_1;
};
protoOf(Companion_57).i64 = function () {
  return this.c68_1;
};
var Companion_instance_63;
function Companion_getInstance_69() {
  return Companion_instance_63;
}
function get_hostAssemblyWithPointSeries() {
  return Companion_instance_63.b68_1;
}
function get_framesWithTopPanel_0() {
  return Companion_instance_63.c68_1;
}
function Frames() {
}
function FrameFrames() {
}
function DoorAssembly_0() {
}
function Front() {
}
function DrawerAssemblies() {
}
function DrawerBodies() {
}
function Legs() {
}
function Shelves() {
}
function TopPanels() {
}
function Knob() {
}
function Handle_0() {
}
function ProductStructure_0() {
}
function Companion_58() {
  Companion_instance_64 = this;
  this.e68_1 = Companion_instance_53;
  this.f68_1 = Companion_instance_52;
  this.g68_1 = Companion_instance_54;
  this.h68_1 = Companion_instance_56;
  this.i68_1 = Companion_instance_57;
  this.j68_1 = Companion_instance_55;
  this.k68_1 = Companion_instance_58;
  this.l68_1 = Companion_instance_59;
  this.m68_1 = Companion_instance_60;
  this.n68_1 = Companion_instance_61;
  this.o68_1 = Companion_instance_62;
  this.p68_1 = Companion_instance_63;
}
protoOf(Companion_58).q68 = function () {
  return this.e68_1;
};
protoOf(Companion_58).s65 = function () {
  return this.f68_1;
};
protoOf(Companion_58).p65 = function () {
  return this.g68_1;
};
protoOf(Companion_58).r68 = function () {
  return this.h68_1;
};
protoOf(Companion_58).s68 = function () {
  return this.i68_1;
};
protoOf(Companion_58).t68 = function () {
  return this.j68_1;
};
protoOf(Companion_58).u68 = function () {
  return this.k68_1;
};
protoOf(Companion_58).x65 = function () {
  return this.l68_1;
};
protoOf(Companion_58).v68 = function () {
  return this.m68_1;
};
protoOf(Companion_58).w68 = function () {
  return this.n68_1;
};
protoOf(Companion_58).x68 = function () {
  return this.o68_1;
};
protoOf(Companion_58).j66 = function () {
  return this.p68_1;
};
var Companion_instance_64;
function Companion_getInstance_70() {
  if (Companion_instance_64 == null)
    new Companion_58();
  return Companion_instance_64;
}
function get_frameFrames() {
  return Companion_getInstance_70().e68_1;
}
function get_frames_0() {
  return Companion_getInstance_70().f68_1;
}
function get_doors_0() {
  return Companion_getInstance_70().g68_1;
}
function get_drawerAssemblies() {
  return Companion_getInstance_70().h68_1;
}
function get_drawerBodies() {
  return Companion_getInstance_70().i68_1;
}
function get_fronts() {
  return Companion_getInstance_70().j68_1;
}
function get_legs() {
  return Companion_getInstance_70().k68_1;
}
function get_shelves_0() {
  return Companion_getInstance_70().l68_1;
}
function get_topPanels() {
  return Companion_getInstance_70().m68_1;
}
function get_knobs() {
  return Companion_getInstance_70().n68_1;
}
function get_handles() {
  return Companion_getInstance_70().o68_1;
}
function get_productStructures_0() {
  return Companion_getInstance_70().p68_1;
}
function CAX() {
  Companion_getInstance_57();
}
function CESTA() {
  Companion_getInstance_70();
}
function Companion_59() {
  Companion_instance_65 = this;
  this.y68_1 = Companion_getInstance_57();
  this.z68_1 = Companion_getInstance_70();
}
protoOf(Companion_59).a69 = function () {
  return this.y68_1;
};
protoOf(Companion_59).b69 = function () {
  return this.z68_1;
};
var Companion_instance_65;
function Companion_getInstance_71() {
  if (Companion_instance_65 == null)
    new Companion_59();
  return Companion_instance_65;
}
function get_cax() {
  return Companion_getInstance_71().y68_1;
}
function get_cesta() {
  return Companion_getInstance_71().z68_1;
}
function CTRItemNo() {
  Companion_getInstance_71();
}
function CountSystem() {
  SystemBase.call(this, 'CountSystem', Companion_instance_2.w1m_1);
  this.enable();
  this.addCount = 0;
  this.updateCount = 0;
  this.removeCount = 0;
}
protoOf(CountSystem).l69 = function (_set____db54di) {
  this.addCount = _set____db54di;
};
protoOf(CountSystem).m69 = function () {
  return this.addCount;
};
protoOf(CountSystem).n69 = function (_set____db54di) {
  this.updateCount = _set____db54di;
};
protoOf(CountSystem).o69 = function () {
  return this.updateCount;
};
protoOf(CountSystem).p69 = function (_set____db54di) {
  this.removeCount = _set____db54di;
};
protoOf(CountSystem).q69 = function () {
  return this.removeCount;
};
protoOf(CountSystem).e4g = function (entity, newComponent) {
  this.addCount = this.addCount + 1 | 0;
};
protoOf(CountSystem).v1v = function (entity, newComponent) {
  return this.e4g(entity, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(CountSystem).f4g = function (entity, oldComponent, newComponent) {
  this.updateCount = this.updateCount + 1 | 0;
};
protoOf(CountSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE();
  return this.f4g(entity, tmp, newComponent instanceof SelectedComponent ? newComponent : THROW_CCE());
};
protoOf(CountSystem).g4g = function (entity, oldComponent) {
  this.removeCount = this.removeCount + 1 | 0;
};
protoOf(CountSystem).z1v = function (entity, oldComponent) {
  return this.g4g(entity, oldComponent instanceof SelectedComponent ? oldComponent : THROW_CCE());
};
protoOf(CountSystem).reset = function () {
  this.addCount = 0;
  this.updateCount = 0;
  this.removeCount = 0;
};
protoOf(CountSystem).j1w = function () {
  // Inline function 'kotlin.emptyArray' call
  return [];
};
function Companion_60() {
}
protoOf(Companion_60).r69 = function (room, sceneManager) {
  if (room == null)
    return Unit_instance;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(room);
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.test.helper.utils.Companion.resnapEntitiesToRoom.<anonymous>' call
    if (!get_isRoomPart(element)) {
      destination.h(element);
    }
  }
  var roomChildren = destination;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = roomChildren.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.test.helper.utils.Companion.resnapEntitiesToRoom.<anonymous>' call
    var snaps = Companion_instance_3.getMatchingSnapsInScene$default(element_0, sceneManager);
    var sortedSnaps = Companion_getInstance_7().s35_1.sortAndSelect(snaps);
    var tmp0_safe_receiver = firstOrNull(sortedSnaps);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.performMoveAndConnect();
    }
  }
};
var Companion_instance_66;
function Companion_getInstance_72() {
  return Companion_instance_66;
}
function resnapEntitiesToRoom(room, sceneManager) {
  return Companion_instance_66.r69(room, sceneManager);
}
function RoomTestHelper() {
}
function createWebSocketConnection(url) {
  return new VoidConnection();
}
function VoidConnection() {
}
protoOf(VoidConnection).send = function (message) {
};
protoOf(VoidConnection).close = function () {
};
//region block: post-declaration
protoOf(RemoteViewer).createSphere = createSphere;
protoOf(RemoteViewer).cloneObject = cloneObject;
protoOf(RemoteViewer).createBox = createBox;
protoOf(RemoteViewer).createPlane = createPlane;
protoOf(RemoteViewer).createSurface = createSurface;
protoOf(RemoteViewer).groupMeshes = groupMeshes;
protoOf(RemoteViewer).createUiLine = createUiLine;
protoOf(RemoteViewer).createUiDashedLine = createUiDashedLine;
protoOf(RemoteViewer).updateUiLine = updateUiLine;
protoOf(RemoteViewer).loadModel = loadModel;
protoOf(RemoteViewer).debug = debug;
protoOf(RemoteViewer).createEmpty = createEmpty;
protoOf(RemoteViewer).createGhostModel = createGhostModel;
protoOf(RemoteViewerObject).setScaleV = setScaleV;
defineProp(protoOf(RemoteViewerObject), 'hasRegisteredInputEvents', function () {
  return this.n33();
});
protoOf($serializer).fx = typeParametersSerializers;
protoOf($serializer_0).fx = typeParametersSerializers;
protoOf($serializer_1).fx = typeParametersSerializers;
protoOf($serializer_2).fx = typeParametersSerializers;
protoOf($serializer_3).fx = typeParametersSerializers;
protoOf($serializer_4).fx = typeParametersSerializers;
protoOf($serializer_5).fx = typeParametersSerializers;
protoOf($serializer_6).fx = typeParametersSerializers;
protoOf($serializer_7).fx = typeParametersSerializers;
protoOf($serializer_8).fx = typeParametersSerializers;
protoOf($serializer_9).fx = typeParametersSerializers;
defineProp(protoOf(TestRoomRemoteRenderer), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(TestRoomRemoteRenderer), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(CountSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(CountSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(CountSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(CountSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(CountSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(CountSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(CountSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(CountSystem), 'isEnabled', function () {
  return this.s1w();
});
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Companion_instance_7 = new Companion_1();
Companion_instance_8 = new Companion_2();
Companion_instance_9 = new Companion_3();
Companion_instance_10 = new Companion_4();
RemoteViewerState_instance = new RemoteViewerState();
Companion_instance_11 = new Companion_5();
Companion_instance_12 = new Companion_6();
Companion_instance_13 = new Companion_7();
Companion_instance_15 = new Companion_9();
Companion_instance_18 = new Companion_12();
Companion_instance_19 = new Companion_13();
Companion_instance_20 = new Companion_14();
Companion_instance_21 = new Companion_15();
Companion_instance_22 = new Companion_16();
Companion_instance_24 = new Companion_18();
Companion_instance_25 = new Companion_19();
Companion_instance_26 = new Companion_20();
Companion_instance_27 = new Companion_21();
Companion_instance_28 = new Companion_22();
Companion_instance_29 = new Companion_23();
Companion_instance_30 = new Companion_24();
Companion_instance_31 = new Companion_25();
Companion_instance_32 = new Companion_26();
Companion_instance_33 = new Companion_27();
Companion_instance_35 = new Companion_29();
Companion_instance_36 = new Companion_30();
Companion_instance_37 = new Companion_31();
Companion_instance_38 = new Companion_32();
Companion_instance_39 = new Companion_33();
Companion_instance_41 = new Companion_35();
Companion_instance_42 = new Companion_36();
Companion_instance_43 = new Companion_37();
Companion_instance_44 = new Companion_38();
Companion_instance_45 = new Companion_39();
Companion_instance_46 = new Companion_40();
Companion_instance_47 = new Companion_41();
Companion_instance_48 = new Companion_42();
Companion_instance_49 = new Companion_43();
Companion_instance_50 = new Companion_44();
Companion_instance_52 = new Companion_46();
Companion_instance_53 = new Companion_47();
Companion_instance_54 = new Companion_48();
Companion_instance_55 = new Companion_49();
Companion_instance_56 = new Companion_50();
Companion_instance_57 = new Companion_51();
Companion_instance_58 = new Companion_52();
Companion_instance_59 = new Companion_53();
Companion_instance_60 = new Companion_54();
Companion_instance_61 = new Companion_55();
Companion_instance_62 = new Companion_56();
Companion_instance_63 = new Companion_57();
Companion_instance_66 = new Companion_60();
//endregion
//region block: exports
TestEntityFactory.createConnectedEntities = createConnectedEntities;
TestEntityFactory.createEntityWithConnector = createEntityWithConnector_0;
TestEntityFactory.createAssemblyEntityWithChildConnectors = createAssemblyEntityWithChildConnectors_0;
TestEntityFactory.addAssemblyChildWithConnector = addAssemblyChildWithConnector_0;
TestEntityFactory.addConnectorToEntity = addConnectorToEntity_0;
TestEntityFactory.addGroundConnectorToEntity = addGroundConnectorToEntity;
TestEntityFactory.assertCreatedRequiredHierarchy = assertCreatedRequiredHierarchy;
TestEntityFactory.assertRevertedRequiredHierarchy = assertRevertedRequiredHierarchy;
TestEntityFactory.hasHostedConnection = hasHostedConnection;
TestEntityFactory.hasGuestConnection = hasGuestConnection;
TestEntityFactory.createHostWith2Connectors = createHostWith2Connectors_0;
TestEntityFactory.createGuestBox = createGuestBox_0;
TestEntityFactory.addWallConnector = addWallConnector;
TestEntityFactory.addFloorEdgeConnector = addFloorEdgeConnector;
TestEntityFactory.makeAlignable = makeAlignable;
defineProp(TestEntityFactory, 'snapToFloorTags', get_snapToFloorTags);
defineProp(TestEntityFactory, 'snapToFloorDemands', get_snapToFloorDemands);
defineProp(TestEntityFactory, 'snapToFloorOffers', get_snapToFloorOffers);
defineProp(TestEntityFactory, 'hostTags', get_hostTags);
defineProp(TestEntityFactory, 'hostOffers', get_hostOffers);
defineProp(TestEntityFactory, 'hostDemands', get_hostDemands);
defineProp(TestEntityFactory, 'guestOffers', get_guestOffers);
defineProp(TestEntityFactory, 'guestDemands', get_guestDemands);
defineProp(TestEntityFactory, 'Companion', Companion_getInstance_11);
AutoAdaptExtensions.makeAutoAdaptHost = makeAutoAdaptHost;
AutoAdaptExtensions.makeAutoAdaptable = makeAutoAdaptable;
defineProp(AutoAdaptExtensions, 'Companion', Companion_getInstance_12);
TestPlacementUtils.createInSceneAndAssert = createInSceneAndAssert;
TestPlacementUtils.createAtPositionAndAssert = createAtPositionAndAssert;
TestPlacementUtils.createInScene = createInScene;
TestPlacementUtils.createAtPosition = createAtPosition;
TestPlacementUtils.createInHostAndAssert = createInHostAndAssert;
TestPlacementUtils.createInHost = createInHost;
TestPlacementUtils.placeProductsInLine = placeProductsInLine_0;
defineProp(TestPlacementUtils, 'Companion', Companion_getInstance_14);
PlacementExtensions.createInSceneAndAssert = createInSceneAndAssert_0;
PlacementExtensions.createInHostAndAssert = createInHostAndAssert_0;
PlacementExtensions.createInScene = createInScene_0;
PlacementExtensions.createInHost = createInHost_0;
PlacementExtensions.createAtPosition = createAtPosition_0;
PlacementExtensions.createAtPositionAndAssert = createAtPositionAndAssert_0;
PlacementExtensions.fillHostWithProduct = fillHostWithProduct;
defineProp(PlacementExtensions, 'Companion', Companion_getInstance_15);
ArrangeExtensions.placeHostProductsInLine = placeHostProductsInLine;
defineProp(ArrangeExtensions, 'Companion', Companion_getInstance_16);
defineProp(CTRItemNo, 'cax', get_cax);
defineProp(CTRItemNo, 'cesta', get_cesta);
CTRItemNo.CAX = CAX;
defineProp(CTRItemNo.CAX, 'clothesRails', get_clothesRails);
defineProp(CTRItemNo.CAX, 'cornerSolutions', get_cornerSolutions);
defineProp(CTRItemNo.CAX, 'cornerAddonFrameWithShelvesProductStructure', get_cornerAddonFrameWithShelvesProductStructure);
defineProp(CTRItemNo.CAX, 'cornerAddonFrames', get_cornerAddonFrames);
defineProp(CTRItemNo.CAX, 'doors', get_doors);
defineProp(CTRItemNo.CAX, 'doorFronts', get_doorFronts);
defineProp(CTRItemNo.CAX, 'drawers', get_drawers);
defineProp(CTRItemNo.CAX, 'frames', get_frames);
defineProp(CTRItemNo.CAX, 'handle', get_handle);
defineProp(CTRItemNo.CAX, 'lDivider', get_lDivider);
defineProp(CTRItemNo.CAX, 'meshBaskets', get_meshBaskets);
defineProp(CTRItemNo.CAX, 'meshBasketBaskets', get_meshBasketBaskets);
defineProp(CTRItemNo.CAX, 'pullOutTraysWithInserts', get_pullOutTraysWithInserts);
defineProp(CTRItemNo.CAX, 'shelves', get_shelves);
defineProp(CTRItemNo.CAX, 'shoeShelves', get_shoeShelves);
defineProp(CTRItemNo.CAX, 'slidingDoor', get_slidingDoor);
defineProp(CTRItemNo.CAX, 'tDivider', get_tDivider);
defineProp(CTRItemNo.CAX, 'valetHanger', get_valetHanger);
defineProp(CTRItemNo.CAX, 'kompBoxSet', get_kompBoxSet);
defineProp(CTRItemNo.CAX, 'drawerMat', get_drawerMat);
defineProp(CTRItemNo.CAX, 'pullOutMultiUseHanger', get_pullOutMultiUseHanger);
defineProp(CTRItemNo.CAX, 'interiorSuggestions', get_interiorSuggestions);
defineProp(CTRItemNo.CAX, 'lights', get_lights);
defineProp(CTRItemNo.CAX, 'shelfBoxes', get_shelfBoxes);
defineProp(CTRItemNo.CAX, 'framesWithInteriors', get_framesWithInteriors);
defineProp(CTRItemNo.CAX, 'productStructures', get_productStructures);
defineProp(CTRItemNo.CAX, 'shoeTrayAssembly', get_shoeTrayAssembly);
CTRItemNo.CAX.Frame = Frame;
defineProp(CTRItemNo.CAX.Frame, 'd100x35x201', get_d100x35x201);
defineProp(CTRItemNo.CAX.Frame, 'd100x35x236', get_d100x35x236);
defineProp(CTRItemNo.CAX.Frame, 'd100x58x236', get_d100x58x236);
defineProp(CTRItemNo.CAX.Frame, 'd100x58x201', get_d100x58x201);
defineProp(CTRItemNo.CAX.Frame, 'd100x58x201_with_offset_bounds', get_d100x58x201_with_offset_bounds);
defineProp(CTRItemNo.CAX.Frame, 'd50x58x236', get_d50x58x236);
defineProp(CTRItemNo.CAX.Frame, 'd50x35x236', get_d50x35x236);
defineProp(CTRItemNo.CAX.Frame, 'd50x58x201', get_d50x58x201);
defineProp(CTRItemNo.CAX.Frame, 'd75x35x236', get_d75x35x236);
defineProp(CTRItemNo.CAX.Frame, 'd75x58x201', get_d75x58x201);
defineProp(CTRItemNo.CAX.Frame, 'Companion', Companion_getInstance_30);
CTRItemNo.CAX.CornerFrameWithShelvesProductStructure = CornerFrameWithShelvesProductStructure;
defineProp(CTRItemNo.CAX.CornerFrameWithShelvesProductStructure, 'd50x35x201', get_d50x35x201);
defineProp(CTRItemNo.CAX.CornerFrameWithShelvesProductStructure, 'd50x58x236', get_d50x58x236_0);
defineProp(CTRItemNo.CAX.CornerFrameWithShelvesProductStructure, 'Companion', Companion_getInstance_31);
CTRItemNo.CAX.CornerAddonFrame = CornerAddonFrame;
defineProp(CTRItemNo.CAX.CornerAddonFrame, 'd50x35x201', get_d50x35x201_0);
defineProp(CTRItemNo.CAX.CornerAddonFrame, 'd50x58x236', get_d50x58x236_1);
defineProp(CTRItemNo.CAX.CornerAddonFrame, 'Companion', Companion_getInstance_32);
CTRItemNo.CAX.CornerSolutions = CornerSolutions;
defineProp(CTRItemNo.CAX.CornerSolutions, 'd100x35x210_35_left', get_d100x35x210_35_left);
defineProp(CTRItemNo.CAX.CornerSolutions, 'd100x35x236_58_left', get_d100x35x236_58_left);
defineProp(CTRItemNo.CAX.CornerSolutions, 'd100x58x210_35_left', get_d100x58x210_35_left);
defineProp(CTRItemNo.CAX.CornerSolutions, 'Companion', Companion_getInstance_33);
CTRItemNo.CAX.ShoeTrayAssembly = ShoeTrayAssembly;
defineProp(CTRItemNo.CAX.ShoeTrayAssembly, 'd100x58', get_d100x58);
defineProp(CTRItemNo.CAX.ShoeTrayAssembly, 'Companion', Companion_getInstance_34);
CTRItemNo.CAX.MeshBasketAssembly = MeshBasketAssembly;
defineProp(CTRItemNo.CAX.MeshBasketAssembly, 'd100x35', get_d100x35);
defineProp(CTRItemNo.CAX.MeshBasketAssembly, 'd100x58', get_d100x58_0);
defineProp(CTRItemNo.CAX.MeshBasketAssembly, 'd50x58', get_d50x58);
defineProp(CTRItemNo.CAX.MeshBasketAssembly, 'Companion', Companion_getInstance_35);
CTRItemNo.CAX.MeshBasketBasket = MeshBasketBasket;
defineProp(CTRItemNo.CAX.MeshBasketBasket, 'd100x58_GRAY', get_d100x58_GRAY);
defineProp(CTRItemNo.CAX.MeshBasketBasket, 'd100x58_WHITE', get_d100x58_WHITE);
defineProp(CTRItemNo.CAX.MeshBasketBasket, 'Companion', Companion_getInstance_36);
CTRItemNo.CAX.Shelf = Shelf;
defineProp(CTRItemNo.CAX.Shelf, 'd100x35', get_d100x35_0);
defineProp(CTRItemNo.CAX.Shelf, 'd100x58', get_d100x58_1);
defineProp(CTRItemNo.CAX.Shelf, 'd75x35', get_d75x35);
defineProp(CTRItemNo.CAX.Shelf, 'd75x58', get_d75x58);
defineProp(CTRItemNo.CAX.Shelf, 'd50x35', get_d50x35);
defineProp(CTRItemNo.CAX.Shelf, 'd50x58', get_d50x58_0);
defineProp(CTRItemNo.CAX.Shelf, 'd50x35_WHITE', get_d50x35_WHITE);
defineProp(CTRItemNo.CAX.Shelf, 'Companion', Companion_getInstance_37);
CTRItemNo.CAX.ShoeShelf = ShoeShelf;
defineProp(CTRItemNo.CAX.ShoeShelf, 'd100x35', get_d100x35_1);
defineProp(CTRItemNo.CAX.ShoeShelf, 'Companion', Companion_getInstance_38);
CTRItemNo.CAX.Drawer = Drawer;
defineProp(CTRItemNo.CAX.Drawer, 'd100x35', get_d100x35_2);
defineProp(CTRItemNo.CAX.Drawer, 'd50x35', get_d50x35_0);
defineProp(CTRItemNo.CAX.Drawer, 'd100x58', get_d100x58_2);
defineProp(CTRItemNo.CAX.Drawer, 'd50x58', get_d50x58_1);
defineProp(CTRItemNo.CAX.Drawer, 'Companion', Companion_getInstance_39);
CTRItemNo.CAX.DoorAssembly = DoorAssembly;
defineProp(CTRItemNo.CAX.DoorAssembly, 'd50x236', get_d50x236);
defineProp(CTRItemNo.CAX.DoorAssembly, 'd50x201', get_d50x201);
defineProp(CTRItemNo.CAX.DoorAssembly, 'd25x201', get_d25x201);
defineProp(CTRItemNo.CAX.DoorAssembly, 'doorsOfAllSizes', get_doorsOfAllSizes);
defineProp(CTRItemNo.CAX.DoorAssembly, 'Companion', Companion_getInstance_40);
CTRItemNo.CAX.DoorFront = DoorFront;
defineProp(CTRItemNo.CAX.DoorFront, 'd50x236', get_d50x236_0);
defineProp(CTRItemNo.CAX.DoorFront, 'd50x201', get_d50x201_0);
defineProp(CTRItemNo.CAX.DoorFront, 'd50x201otherColor', get_d50x201otherColor);
defineProp(CTRItemNo.CAX.DoorFront, 'Companion', Companion_getInstance_41);
CTRItemNo.CAX.ClothesRails = ClothesRails;
defineProp(CTRItemNo.CAX.ClothesRails, 'd100x58', get_d100x58_3);
defineProp(CTRItemNo.CAX.ClothesRails, 'd50x58', get_d50x58_2);
defineProp(CTRItemNo.CAX.ClothesRails, 'd100x35', get_d100x35_3);
defineProp(CTRItemNo.CAX.ClothesRails, 'Companion', Companion_getInstance_42);
CTRItemNo.CAX.ValetHanger = ValetHanger;
defineProp(CTRItemNo.CAX.ValetHanger, 'white', get_white);
defineProp(CTRItemNo.CAX.ValetHanger, 'Companion', Companion_getInstance_43);
CTRItemNo.CAX.TDivider = TDivider;
defineProp(CTRItemNo.CAX.TDivider, 'd100x58', get_d100x58_4);
defineProp(CTRItemNo.CAX.TDivider, 'Companion', Companion_getInstance_44);
CTRItemNo.CAX.LDivider = LDivider;
defineProp(CTRItemNo.CAX.LDivider, 'right35', get_right35);
defineProp(CTRItemNo.CAX.LDivider, 'left35', get_left35);
defineProp(CTRItemNo.CAX.LDivider, 'right58', get_right58);
defineProp(CTRItemNo.CAX.LDivider, 'left58', get_left58);
defineProp(CTRItemNo.CAX.LDivider, 'Companion', Companion_getInstance_45);
CTRItemNo.CAX.SlidingDoor = SlidingDoor;
defineProp(CTRItemNo.CAX.SlidingDoor, 'slidingDoor150x201', get_slidingDoor150x201);
defineProp(CTRItemNo.CAX.SlidingDoor, 'slidingDoor150x236', get_slidingDoor150x236);
defineProp(CTRItemNo.CAX.SlidingDoor, 'slidingDoor200x201', get_slidingDoor200x201);
defineProp(CTRItemNo.CAX.SlidingDoor, 'slidingDoor200x236', get_slidingDoor200x236);
defineProp(CTRItemNo.CAX.SlidingDoor, 'doorsOfAllSizes', get_doorsOfAllSizes_0);
defineProp(CTRItemNo.CAX.SlidingDoor, 'Companion', Companion_getInstance_46);
CTRItemNo.CAX.Handle = Handle;
defineProp(CTRItemNo.CAX.Handle, 'vinna357Stainless', get_vinna357Stainless);
defineProp(CTRItemNo.CAX.Handle, 'osternasAlwaysHangDownHandle', get_osternasAlwaysHangDownHandle);
defineProp(CTRItemNo.CAX.Handle, 'longLongHandle', get_longLongHandle);
defineProp(CTRItemNo.CAX.Handle, 'Companion', Companion_getInstance_47);
CTRItemNo.CAX.PullOutTrayWithInserts = PullOutTrayWithInserts;
defineProp(CTRItemNo.CAX.PullOutTrayWithInserts, 'shoeInserts100x58', get_shoeInserts100x58);
defineProp(CTRItemNo.CAX.PullOutTrayWithInserts, 'Companion', Companion_getInstance_48);
CTRItemNo.CAX.DrawerMat = DrawerMat;
defineProp(CTRItemNo.CAX.DrawerMat, 'mat100x58', get_mat100x58);
defineProp(CTRItemNo.CAX.DrawerMat, 'mat50x58', get_mat50x58);
defineProp(CTRItemNo.CAX.DrawerMat, 'Companion', Companion_getInstance_49);
CTRItemNo.CAX.KompBoxSet = KompBoxSet;
defineProp(CTRItemNo.CAX.KompBoxSet, 'boxSet100x58', get_boxSet100x58);
defineProp(CTRItemNo.CAX.KompBoxSet, 'boxSet50x58', get_boxSet50x58);
defineProp(CTRItemNo.CAX.KompBoxSet, 'Companion', Companion_getInstance_50);
CTRItemNo.CAX.PullOutMultiUseHanger = PullOutMultiUseHanger;
defineProp(CTRItemNo.CAX.PullOutMultiUseHanger, 'd35', get_d35);
defineProp(CTRItemNo.CAX.PullOutMultiUseHanger, 'd58', get_d58);
defineProp(CTRItemNo.CAX.PullOutMultiUseHanger, 'Companion', Companion_getInstance_51);
CTRItemNo.CAX.InteriorSuggestion = InteriorSuggestion;
defineProp(CTRItemNo.CAX.InteriorSuggestion, 'cax1', get_cax1);
defineProp(CTRItemNo.CAX.InteriorSuggestion, 'cax2', get_cax2);
defineProp(CTRItemNo.CAX.InteriorSuggestion, 'Companion', Companion_getInstance_52);
CTRItemNo.CAX.Light = Light;
defineProp(CTRItemNo.CAX.Light, 'outer', get_outer);
defineProp(CTRItemNo.CAX.Light, 'inner67', get_inner67);
defineProp(CTRItemNo.CAX.Light, 'inner92', get_inner92);
defineProp(CTRItemNo.CAX.Light, 'Companion', Companion_getInstance_53);
CTRItemNo.CAX.ShelfBox = ShelfBox;
defineProp(CTRItemNo.CAX.ShelfBox, 'd100x58', get_d100x58_5);
defineProp(CTRItemNo.CAX.ShelfBox, 'd50x58', get_d50x58_3);
defineProp(CTRItemNo.CAX.ShelfBox, 'Companion', Companion_getInstance_54);
CTRItemNo.CAX.FrameWithInteriors = FrameWithInteriors;
defineProp(CTRItemNo.CAX.FrameWithInteriors, 'frameWithInteriors', get_frameWithInteriors);
defineProp(CTRItemNo.CAX.FrameWithInteriors, 'Companion', Companion_getInstance_55);
CTRItemNo.CAX.ProductStructure = ProductStructure;
defineProp(CTRItemNo.CAX.ProductStructure, 'slidingDoor4x50x201', get_slidingDoor4x50x201);
defineProp(CTRItemNo.CAX.ProductStructure, 'slidingDoor2x100x201', get_slidingDoor2x100x201);
defineProp(CTRItemNo.CAX.ProductStructure, 'flatProductStructure', get_flatProductStructure);
defineProp(CTRItemNo.CAX.ProductStructure, 'deepFlatProductStructure', get_deepFlatProductStructure);
defineProp(CTRItemNo.CAX.ProductStructure, 'flatProductStructureWithTransform', get_flatProductStructureWithTransform);
defineProp(CTRItemNo.CAX.ProductStructure, 'flatProductStructureMissingPart', get_flatProductStructureMissingPart);
defineProp(CTRItemNo.CAX.ProductStructure, 'framesWithTopPanel', get_framesWithTopPanel);
defineProp(CTRItemNo.CAX.ProductStructure, 'flatProductStructureWithSnapAndTransform', get_flatProductStructureWithSnapAndTransform);
defineProp(CTRItemNo.CAX.ProductStructure, 'Companion', Companion_getInstance_56);
defineProp(CTRItemNo.CAX, 'Companion', Companion_getInstance_57);
CTRItemNo.CESTA = CESTA;
defineProp(CTRItemNo.CESTA, 'frameFrames', get_frameFrames);
defineProp(CTRItemNo.CESTA, 'frames', get_frames_0);
defineProp(CTRItemNo.CESTA, 'doors', get_doors_0);
defineProp(CTRItemNo.CESTA, 'drawerAssemblies', get_drawerAssemblies);
defineProp(CTRItemNo.CESTA, 'drawerBodies', get_drawerBodies);
defineProp(CTRItemNo.CESTA, 'fronts', get_fronts);
defineProp(CTRItemNo.CESTA, 'legs', get_legs);
defineProp(CTRItemNo.CESTA, 'shelves', get_shelves_0);
defineProp(CTRItemNo.CESTA, 'topPanels', get_topPanels);
defineProp(CTRItemNo.CESTA, 'knobs', get_knobs);
defineProp(CTRItemNo.CESTA, 'handles', get_handles);
defineProp(CTRItemNo.CESTA, 'productStructures', get_productStructures_0);
CTRItemNo.CESTA.Frames = Frames;
defineProp(CTRItemNo.CESTA.Frames, 'd60x20x64', get_d60x20x64);
defineProp(CTRItemNo.CESTA.Frames, 'd60x40x128', get_d60x40x128);
defineProp(CTRItemNo.CESTA.Frames, 'd60x40x38', get_d60x40x38);
defineProp(CTRItemNo.CESTA.Frames, 'd60x40x38wood', get_d60x40x38wood);
defineProp(CTRItemNo.CESTA.Frames, 'd60x20x38', get_d60x20x38);
defineProp(CTRItemNo.CESTA.Frames, 'Companion', Companion_getInstance_58);
CTRItemNo.CESTA.FrameFrames = FrameFrames;
defineProp(CTRItemNo.CESTA.FrameFrames, 'd60x20x64', get_d60x20x64_0);
defineProp(CTRItemNo.CESTA.FrameFrames, 'd60x40x128', get_d60x40x128_0);
defineProp(CTRItemNo.CESTA.FrameFrames, 'd60x40x38', get_d60x40x38_0);
defineProp(CTRItemNo.CESTA.FrameFrames, 'd60x40x38wood', get_d60x40x38wood_0);
defineProp(CTRItemNo.CESTA.FrameFrames, 'd60x20x38', get_d60x20x38_0);
defineProp(CTRItemNo.CESTA.FrameFrames, 'Companion', Companion_getInstance_59);
CTRItemNo.CESTA.DoorAssembly = DoorAssembly_0;
defineProp(CTRItemNo.CESTA.DoorAssembly, 'd60x64', get_d60x64);
defineProp(CTRItemNo.CESTA.DoorAssembly, 'd60x38', get_d60x38);
defineProp(CTRItemNo.CESTA.DoorAssembly, 'Companion', Companion_getInstance_60);
CTRItemNo.CESTA.Front = Front;
defineProp(CTRItemNo.CESTA.Front, 'd60x38', get_d60x38_0);
defineProp(CTRItemNo.CESTA.Front, 'd60x38wood', get_d60x38wood);
defineProp(CTRItemNo.CESTA.Front, 'Companion', Companion_getInstance_61);
CTRItemNo.CESTA.DrawerAssemblies = DrawerAssemblies;
defineProp(CTRItemNo.CESTA.DrawerAssemblies, 'd60x38_softclosing', get_d60x38_softclosing);
defineProp(CTRItemNo.CESTA.DrawerAssemblies, 'Companion', Companion_getInstance_62);
CTRItemNo.CESTA.DrawerBodies = DrawerBodies;
defineProp(CTRItemNo.CESTA.DrawerBodies, 'd60x38', get_d60x38_1);
defineProp(CTRItemNo.CESTA.DrawerBodies, 'd60x38wood', get_d60x38wood_0);
defineProp(CTRItemNo.CESTA.DrawerBodies, 'Companion', Companion_getInstance_63);
CTRItemNo.CESTA.Legs = Legs;
defineProp(CTRItemNo.CESTA.Legs, 'd10_STUBBARP', get_d10_STUBBARP);
defineProp(CTRItemNo.CESTA.Legs, 'mergableLeg', get_mergableLeg);
defineProp(CTRItemNo.CESTA.Legs, 'framePad', get_framePad);
defineProp(CTRItemNo.CESTA.Legs, 'Companion', Companion_getInstance_64);
CTRItemNo.CESTA.Shelves = Shelves;
defineProp(CTRItemNo.CESTA.Shelves, 'd60x20', get_d60x20);
defineProp(CTRItemNo.CESTA.Shelves, 'd60x40', get_d60x40);
defineProp(CTRItemNo.CESTA.Shelves, 'Companion', Companion_getInstance_65);
CTRItemNo.CESTA.TopPanels = TopPanels;
defineProp(CTRItemNo.CESTA.TopPanels, 'd120x40', get_d120x40);
defineProp(CTRItemNo.CESTA.TopPanels, 'Companion', Companion_getInstance_66);
CTRItemNo.CESTA.Knob = Knob;
defineProp(CTRItemNo.CESTA.Knob, 'edvalla_hanging', get_edvalla_hanging);
defineProp(CTRItemNo.CESTA.Knob, 'Companion', Companion_getInstance_67);
CTRItemNo.CESTA.Handle = Handle_0;
defineProp(CTRItemNo.CESTA.Handle, 'osternas_hanging', get_osternas_hanging);
defineProp(CTRItemNo.CESTA.Handle, 'Companion', Companion_getInstance_68);
CTRItemNo.CESTA.ProductStructure = ProductStructure_0;
defineProp(CTRItemNo.CESTA.ProductStructure, 'hostAssemblyWithPointSeries', get_hostAssemblyWithPointSeries);
defineProp(CTRItemNo.CESTA.ProductStructure, 'framesWithTopPanel', get_framesWithTopPanel_0);
defineProp(CTRItemNo.CESTA.ProductStructure, 'Companion', Companion_getInstance_69);
defineProp(CTRItemNo.CESTA, 'Companion', Companion_getInstance_70);
defineProp(CTRItemNo, 'Companion', Companion_getInstance_71);
RoomTestHelper.resnapEntitiesToRoom = resnapEntitiesToRoom;
defineProp(RoomTestHelper, 'Companion', Companion_getInstance_72);
export {
  EntityWithPointConnector as EntityWithPointConnector,
  GuestAndHost as GuestAndHost,
  TestEntityFactory as TestEntityFactory,
  AutoAdaptExtensions as AutoAdaptExtensions,
  TestPlacementUtils as TestPlacementUtils,
  PlacementExtensions as PlacementExtensions,
  ArrangeExtensions as ArrangeExtensions,
  enableRemoteViewerJS as enableRemoteViewerJS,
  CTRItemNo as CTRItemNo,
  CountSystem as CountSystem,
  RoomTestHelper as RoomTestHelper,
};
//endregion

//# sourceMappingURL=core-test-helpers.mjs.map
